/*
  Red Lobster Golfing – Konfigurator „Personalisierte Golfbälle“ (Phase 1, 02.10.2026)
  Geladen nur über snippets/rlg-personalisierung.liquid (Vorlage product.personalisiert), defer, ohne Bibliotheken.

  Maßstab: Ball Ø 42,67 mm, Druckkreis Ø 20 mm, interner sicherer Bereich Ø 18 mm (nur Hilfslinie).
  Druck-PNG: 1200 × 1200 px transparent = genau der 20-mm-Kreis (60 px/mm), ohne Ball.
  Druck-PNG mit Bild (03.10.2026): Pixel mit R, G, B ≥ 245 → Alpha 0, min(R,G,B) 235–245 weich abgeblendet
  (eufy Studio legt unter deckendes Weiß sonst eine Weiß-Ebene; JPEG-Rauschen soll nicht als Schleier drucken).
  Vorschau-PNG und Live-Vorschau bleiben unverändert.
  Vorschau-PNG: Ball mit Motiv (multiply), 800 × 800 px je Seite, bei beidseitig 1600 × 800.
  Uploads: POST JSON an motiv-upload → { code, path, signedUrl } → PUT signedUrl (Body = Datei).
  Integrität (03.10.2026): SHA-256 jeder hochgeladenen Datei → versteckte Properties _SHA_Druck_n, _SHA_Vorschau, _SHA_Original_n.
  Viertes Pflicht-Häkchen (04.10.2026, Plan v2 Eintrag 63): Hat ein verwendetes Bild weniger als 600 px Breite oder Höhe,
  erscheint data-rp-check="aufloesung" (sonst versteckt, deaktiviert, nicht Pflicht). Neues/anderes Bild → wieder abgewählt.
  Beim Absenden: verstecktes Property _Aufloesung „Unschärfe akzeptiert: Seite n W × H px (unter 600 px)“.
  Entweder-oder (07.10.2026): je Seite gilt genau eine Art (artOf: 'bild' | 'text', BOLD immer 'text'). Nur sie ist bedienbar
  und geht in Vorschau, Druck-PNG, Vorschau-PNG und Properties; die andere Eingabe bleibt erhalten (ausgeblendet, nicht gedruckt,
  nicht übertragen). Größe/Drehung/Position gelten je Art (side.tf), ein Wechsel stellt den Stand der Art wieder her.
  Korrektur nach Review (08.10.2026): Art-, Schrift- und Farb-Radios mit autocomplete="off" (Chromium stellt formularlose Radios
  beim Zurück ohne bfcache sonst nach dem Start wieder her, ohne change); pageshow zeichnet den Stand aus dem JS neu, ein Klick
  auf die schon markierte Art wirkt. Revisionszähler rev (designChanged): Ändert sich während „Wird vorbereitet“ irgendetwas am
  Motiv, bricht das Absenden ab und die Freigabe ist aufgehoben; Schalter, Text, Datei und Häkchen sind währenddessen gesperrt.
  3D-Vorschau (08.10.2026): renderPrintCanvas = Druck-PNG als Canvas (aus renderPrintBlob ausgelagert, Abfolge unverändert) – daraus
  zeichnet das 3D-Modul assets/rlg-perso-3d.js (modernes JS, lädt erst beim ersten Klick auf „3D“) die Balltextur. Hier nur die
  Andockstelle (ES5): Umschalter „Vorschau 2D | 3D“ (Modus aus cfg.d3: „an“ oder Testmodus mit ?rlg3d=1), Lader, Haken in drawPreview,
  setActive und Nahansicht. Jeder Teil in try/catch: Ein 3D-Fehler schaltet nur 3D ab, Kauf, Druck-PNG und Properties bleiben unberührt.
  Korrektur 09.10.2026: beim Laden wertet nur der jüngste Klick auf „3D“ aus; setzt ein Variantenwechsel die aktive Seite zurück
  (beidseitig → einseitig), folgt die 3D-Kamera (Haken in syncFromTheme).
  Auflösung je Motiv (09.10.2026, ersetzt die 600-px-Regel für das vierte Häkchen): maßgeblich sind die Pixel des gedruckten Bildes
  ohne leeren Rand (s.img nach analyzeAndTrim) geteilt durch seine gedruckte Breite in mm bei der aktuellen Größe = effektive dpi.
  Unter REC_DPI (400) erscheinen Hinweis (mit größtem scharfen Zoom) und viertes Häkchen, live je Größe. Das Häkchen gilt nur mit
  dem Stand beim Ankreuzen (resAck): größer gezogen (weniger dpi), neues Bild (s.imgGen) oder ohne Ankreuz-Ereignis → abgewählt.
  Große Bilder (> 2048 px) mit kleinem Motiv: Das Motiv wird in Originalauflösung aus dem Bild geschnitten (vollAusschnitt), statt
  aus der verkleinerten Arbeitsfläche – sonst verlöre es Pixel, die der Kunde geliefert hat. Gilt nur ohne manuelle EXIF-Drehung und
  wenn der Ausschnitt ≤ 2048 px ist; alle anderen Bilder bleiben bytegleich. Der Bogen druckt seit 09.10.2026 mit 720 dpi.
  MIN_PX (ganzes Bild ≥ 300 px) bleibt als harte Grenze. _Aufloesung: „Seite n W × H px auf M mm ≈ D dpi (unter 400 dpi)“.
  11.10.2026 (kompakt, SPEC_kompakt §1–2):
  - Auto-Größe: Größe/Drehung/Lage stellt niemand mehr ein. layout() misst die Tinte einmal je Layout (measureInk: eine wieder-
    verwendete Messleinwand, MESS_PPM, Bild nach knockOutWhite, Tinte = Alpha > 0) und legt fit/ox/oy in den Layout-Cache:
    Mitte der Tinten-Box auf die Kreismitte, weitester Tinten-Pixel (Pixelecke) auf FIT_R_MM, Drehung 0, Lage 0,0.
    Messung gescheitert/leer/am Rand der Messleinwand → fit = 1, ox = oy = 0 (alte 100-%-Regel, Diagonale 16,9 mm, sicher).
    s.zoom/rot/x/y werden bei jedem layout() aus dem Cache gesetzt (nur noch Anzeige/3D-Signatur), gezeichnet wird aus L.
  - Endkontrolle vor dem Hochladen jeder Druck-PNG (1200 px = 20 mm, PRINT_PX/PRINT_MM unverändert): weitester Pixel mit
    Alpha > 0 ≤ CHECK_R_MM (9,05 mm), sonst Abbruch mit t.err_vorbereitung (fail closed).
  - Entfernt: Regler, Zentrieren/Zurücksetzen, Ziehen, Pinch, Tastatur am Canvas, Randwarnung (checkBounds/warn_*), Zoom-Rat im
    dpi-Hinweis (immer hint_aufl_datei). Alte Seiten (Regler/Bedienhinweis im Markup) blendet legacyAus() aus; Canvas ohne
    tabindex, touch-action auto (Seite scrollt beim Wischen über der Vorschau).
  - Häkchen: Pflicht ist mindestens ein aktives (sichtbar, nicht disabled) Freigabe-Häkchen – in validate UND allChecked;
    vor dem Fokus wird ein umgebendes <details> geöffnet. Tab-Leiste nur bei beidseitig. Weihnachts-Hinweise (data-rp-bis)
    werden im ganzen Dokument geprüft (Hinweise stehen seit 11.10. unter dem Kaufbutton, außerhalb des Konfigurators).
  - Properties: _Position_n = 0.0,0.0, _Rotation_n = 0, _Groesse_mm_n = gemessene Tintenbreite × fit; _Rechte/_Widerruf =
    t.prop_hinweis („Hinweis angezeigt“), solange das Markup keine Rechte-/Widerrufs-Häkchen mehr hat; bei bestätigtem
    dpi-Häkchen zusätzlich sichtbar t.prop_aufloesung_name = t.prop_aufloesung_wert.
  11.10.2026 (kompakt, Fix Runde 1 nach T1–T6):
  - Nachkalibrierung (kalibriere, nur Bilder): Nach measureInk wird die echte Druck-PNG gerendert und vermessen (druckRadiusMm, Kriterium der
    Endkontrolle); liegt der weiteste Pixel über FIT_R_MM, wird fit verkleinert, bis er darunter liegt (höchstens KAL_MAX Durchgänge).
    Grund: JPEG-Säume (min RGB 240–245) verschwinden bei der Messung (40 px/mm, verkleinert), bleiben aber im Druck (60 px/mm × fit)
    → Endkontrolle sperrte 3–4 von 80 JPEG-Logos dauerhaft. Endkontrolle selbst unverändert (≤ CHECK_R_MM, fail closed).
    Geht die Kalibrierung nicht auf (Messung offenbar falsch), Rückfall fit 1 wie bei gescheiterter Messung.
  - Rand-Rauschen (analyzeAndTrim): Rand fast nur Weiß mit verstreuten hellgrauen Pixeln (JPEG/Scan) → beim Zuschnitt zählen
    hellgraue, ungesättigte Pixel als Hintergrund (Pixel selbst unverändert, Knockout unverändert) + Hinweis t.hint_rand.
  - Endkontrolle: Ausnahme beim Rendern/Messen = gescheiterte Endkontrolle (t.err_vorbereitung, keine technische Meldung).
  - Häkchen in einem zugeklappten <details> gelten nicht als gesetzt (freigabeAktiv, validate, allChecked); fehlt nur das
    dpi-Häkchen, eigene Meldung t.err_haekchen_dpi. OK-Meldungen nach dem Upload in einer Zeile.
  11.10.2026 (kompakt, Fix Runde 2 nach T5 Q1/T2):
  - Rausch-Modus (rauschBox): Hellgraue Pixel fallen nur noch als kleine, vereinzelte Gruppen aus dem Zuschnitt. Zusammenhängende
    hellgraue Gruppen ab RAUSCH_MIN_PX bzw. RAUSCH_MIN_ANTEIL der Bildfläche (Bänder, Claims, helle Logos) zählen als Motiv, kleinere
    nur, wenn sie höchstens RAUSCH_NAH (2 % der kürzeren Bildseite) vom Motiv entfernt liegen (Punkte, feine Schrift). Kein Motiv
    übrig oder Kette zu lang → normaler Zuschnitt (alle Tinte, wie ohne Rausch-Modus). Ohne Rausch-Modus unverändert.
  - kalibriere: Musste fit korrigiert werden, kommt die Tintenbreite (_Groesse_mm_n) aus der gerenderten Druck-PNG statt aus der Messung.
  11.10.2026 (kompakt, Fix Runde 3 nach T5 r3/T6 r3/T2 r2):
  - Bild-Messung ohne Verkleinerung (tinteBild): weitester Tinten-Pixel (Kriterium der Druck-PNG nach Knockout, Alpha > 0) direkt auf den
    Pixeln des zugeschnittenen Bildes (Arbeitsauflösung) – feine helle Linien (1-px-Rahmen, Ring) gehen nicht mehr verloren, beide Engines gleich.
  - Prüfdarstellung ohne Kreis-Clip (pruefRadiusMm): Druck-Rendering 26 mm × 26 mm bei 60 px/mm (1560 px, eine wiederverwendete Leinwand),
    Tinte am Leinwandrand oder Bild-Rechteck außerhalb = Ausmaß unbekannt = zu groß. kalibriere (Bild UND Text) und Endkontrolle prüfen dort.
  - kalibriere: Bisektion zwischen größtem sicheren (r ≤ FIT_R_MM) und kleinstem unsicheren fit, Vorschlag proportional innerhalb der
    Grenzen, höchstens KAL_MAX Darstellungen; Ziel FIT_MIN_MM ≤ r ≤ FIT_R_MM. Bild: nie größer als Quell-Tinte auf FIT_R_MM (Kappe).
    Kein sicherer Wert → Rückfall fit 1. Endkontrolle: Prüfdarstellung ≤ CHECK_R_MM UND Druck-PNG ≤ CHECK_R_MM, sonst Abbruch.
  - _Groesse_mm_n = Tintenbreite der tatsächlich hochgeladenen Druck-PNG (immer, auch im Rückfall).
  - Hinweis t.hint_punkte: vergrößern dünne/vereinzelte Pixel (Punkte, Flecken, Linien) den Zuschnitt deutlich (Fläche ≥ 1,5 × dichter Kern,
    Dichte außerhalb des Kerns ≤ 2 %), werden sie mitgedruckt und der Kunde erfährt es. t.hint_rand nur noch, wenn wirklich etwas wegfiel.
  - 2D-Vorschau ohne gestrichelte 18-mm-Linie (roter 20-mm-Kreis bleibt); 3D unverändert.
  11.10.2026 (kompakt, Fix Runde 4 nach T6 r4/T2 r3/T5 r4/T1 r4):
  - Kern-Zuschnitt auf Wunsch: Erscheint t.hint_punkte, steht direkt darunter der Knopf [data-rp-kern] (t.kern_an). Klick → Motiv dieser
    Seite auf den dichten Kern (duenneTinte, + kleiner Rand) zugeschnitten, vereinzelte Punkte darin entfernt (kernSaeubern) – side.imgKern,
    beim Hochladen einmal berechnet, große Bilder wie vollAusschnitt aus dem Original –, Auto-Größe/Vorschau/3D neu, designChanged(). Knopf dann t.kern_aus → zurück auf das ganze Bild
    (side.imgGanz, derselbe Canvas wie vorher). Zustand je Seite (side.kernAn), neues/entferntes Bild setzt zurück. Original-Upload
    unverändert; bei Kern-Zuschnitt verstecktes Property _Zuschnitt_n = t.prop_zuschnitt. Ohne Knopf/Texte im Markup (altes Snippet): nichts.
  - Text: Prüfdarstellung (pruefRadiusMm) prüft die Box des gesetzten Textes – gemessene Tinte bei fit 1 (L.tinteBox, measureInk), ohne
    Messung die Glyphen-Box (actualBoundingBox je Zeile, L.tb; ohne diese Maße L.W × L.H) – mit 25 % Reserve bei aktuellem fit/ox/oy gegen
    die Prüfleinwand: außerhalb = Infinity (Endkontrolle bricht ab). Gelesen wird nur diese Box (+2 px); Tinte am Box-Rand = Ausmaß unbekannt
    = Infinity. measureInk liest bei Text nur die Glyphen-Box (+25 %). Nicht wörtlich L.W × L.H: die Zeilenhöhe (Referenz „HÄgjpÖy“) ist bei
    einzelnen Zeichen viel höher als die Tinte – 30 von 68 Probetexten (z. B. „I“, „1“, „g“) wären sonst kleiner gedruckt worden.
    Kalibrierung bleibt synchron (kein ungeprüfter Zwischenstand, keine Entprellung nötig). Bild-Weg unverändert.
  12.10.2026 (kompakt, Fix Runde 5 nach T1 r5/T5 r5/T6 r5):
  - Kern-Zustand: statt t.hint_punkte der Info-Text t.kern_info (is-info); ohne verfügbaren Kern-Ausschnitt (Fehler beim Berechnen) der
    Hinweis ohne Knopf-Verweis t.hint_punkte_ohne. Umschalten → kurze Meldung in [data-rp-status] (t.kern_status_an/_aus, ggf. + t.geaendert).
    Die Meldungsliste [data-rp-msgs] (aria-live) wird nur neu aufgebaut, wenn sich ihr Inhalt ändert.
  - Schriften: Ladezustand je Schrift selbst geführt (fontSt: laedt | loaded | error). WebKit meldet FontFace.status 'error', solange
    die Datei nach der Blockzeit noch lädt – das galt bisher als fertig (Kauf mit Ersatzschrift). Jetzt gilt nur status 'loaded';
    'error' erst nach SCHRIFT_FRIST_MS. Beides sperrt das Absenden (t.err_schrift, auch in der Kette vor jeder Text-Druck-PNG).
    Lädt die Schrift später: Layouts neu (invalidate) und Freigabe-Häkchen ab, wenn eine Seite Text in dieser Schrift hat.
  - Speicher: Kern-Ausschnitt erst beim ersten Klick (kernBerechnen: Datei neu dekodieren, kernAusschnitt wie bisher); die Erkennung
    (duenneTinte) läuft weiter beim Hochladen. Nicht weiterverwendete Leinwände (Arbeitsfläche, roh, Voll-Ausschnitt) → 1 × 1 px.
  - Endkontrolle beim Absenden zusätzlich unabhängig von Boxen (endRadiusMm): ganze Prüfleinwand lesen, bei Text dazu eine grobe
    Leinwand (128 mm) und Zeilenanker – Tinte jenseits der Prüfleinwand gilt als zu groß. Abbruch, wenn eine der Prüfungen > CHECK_R_MM.
*/
(function () {
  'use strict';

  var BALL_MM = 42.67;
  var PRINT_MM = 20;
  var SAFE_MM = 18;
  var PRINT_PX = 1200;
  var MAX_BYTES = 20 * 1024 * 1024;
  var MIN_PX = 300;
  var REC_DPI = 400; // effektive Auflösung des gedruckten Motivs (Pixel ohne Rand / gedruckte Breite), darunter Hinweis + viertes Häkchen
  // 11.10.2026 (kompakt): Auto-Größe. Weitester Tinten-Pixel liegt auf FIT_R_MM vom Kreismittelpunkt (eigene Konstante, nicht SAFE_MM/2:
  // Lage-Toleranz am Drucker max. 0,99 mm → ≤ 9,94 mm < 10 mm; Schärfe am Rand erst nach Test T2 bestätigt – Wert dann hier anpassen).
  var FIT_R_MM = 8.95;
  var CHECK_R_MM = 9.05; // Endkontrolle an der fertigen Druck-PNG (fail closed)
  // Fix r3: Kalibrierung an der unbeschnittenen Prüfdarstellung – Ziel FIT_MIN_MM ≤ r ≤ FIT_R_MM (Vorschlag auf FIT_ZIEL_MM), Bisektion
  var FIT_MIN_MM = 8.85, FIT_ZIEL_MM = 8.9, KAL_MAX = 8;
  // Prüfdarstellung ohne Kreis-Clip: 26 mm Kante bei 60 px/mm (wie die Druck-PNG) = 1560 px, 2,4 Mio. Pixel, eine Leinwand je Instanz
  var PRUEF_PPM = PRINT_PX / PRINT_MM, PRUEF_PX = Math.round(26 * PRUEF_PPM);
  var MESS_PPM = 40;     // Messraster px/mm
  // Messleinwand: halbe Box-Diagonale bei fit 1 = SAFE_MM/2 · 0,94 (= 8,46 mm, s. layout) + 25 % Reserve für Überhänge + 0,5 mm → 886 px
  var MESS_PX = Math.ceil(2 * ((SAFE_MM / 2) * 0.94 * 1.25 + 0.5) * MESS_PPM);
  var MAX_WORK_PX = 2048;
  var MAX_CANVAS_AREA = 16777216; // iOS-Safari-Grenze
  var MAX_LINE = 14;
  var CODE_RE = /^RLG-[A-HJ-NP-Z2-9]{8}$/;
  // Optionswert „Druck“/„Print“: DE einseitig/beidseitig, EN one side/both sides (Produkt-Übersetzung 04.10.2026)
  var SIDES_TWO_RE = /beidseitig|both sides/i;
  var SIDES_ANY_RE = /beidseitig|einseitig|both sides|one side/i;
  // Zeichen, die die vier Schriften abdecken (cmap der WOFF2-Dateien, ausgelesen mit _test/tools/font_coverage.cjs):
  // druckbares ASCII, Latin-1 ohne weiches Trennzeichen, Œ œ – — ‘ ’ ‚ “ ” „ … €. Alles andere (Emoji, kyrillisch,
  // chinesisch …) würde in einer Ersatzschrift gedruckt und wird beim Tippen entfernt.
  var FONT_OK_RE = /^[\u0020-\u007e\u00a1-\u00ac\u00ae-\u00ff\u0152\u0153\u2013\u2014\u2018-\u201a\u201c-\u201e\u2026\u20ac]$/;
  var FONT_MISSING = { playfair: '\u00b5' }; // je Schrift zusätzlich fehlende Zeichen (Playfair Display: µ)
  function fontCovers(fontId, ch) {
    if (!FONT_OK_RE.test(ch)) return false;
    var miss = FONT_MISSING[fontId];
    return !(miss && miss.indexOf(ch) !== -1);
  }
  // entfernt nicht druckbare Zeichen; zählt Codepoints (Emoji = Surrogatpaar)
  function filterChars(fontId, v) {
    var out = '', removed = false;
    Array.from(String(v)).forEach(function (ch) {
      if (fontCovers(fontId, ch)) out += ch; else removed = true;
    });
    return { value: out, removed: removed };
  }

  // ------------------------------------------------------------------ Hilfen
  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function fill(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return map && map[k] != null ? map[k] : m; });
  }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function round1(v) { return (Math.round(v * 10) / 10).toFixed(1); }
  function el(tag, attrs, text) {
    var e = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    if (text != null) e.textContent = text;
    return e;
  }
  function canvasToBlob(canvas, type) {
    return new Promise(function (resolve, reject) {
      try {
        canvas.toBlob(function (b) { b ? resolve(b) : reject(new Error('toBlob')); }, type || 'image/png');
      } catch (e) { reject(e); }
    });
  }
  // Blob.arrayBuffer fehlt in älterem iOS-Safari (< 14) → FileReader
  function readBuf(blob) {
    if (blob.arrayBuffer) return blob.arrayBuffer();
    return new Promise(function (resolve, reject) {
      var fr = new FileReader();
      fr.onload = function () { resolve(fr.result); };
      fr.onerror = function () { reject(fr.error); };
      fr.readAsArrayBuffer(blob);
    });
  }
  // SHA-256 (Hex klein) genau der Bytes, die hochgeladen werden → versteckte Properties _SHA_…
  // motive_holen.py vergleicht damit die Dateien im Speicher. Ohne crypto.subtle (sehr alte Browser,
  // unsichere Herkunft) bleibt die Prüfsumme leer; das Absenden wird dadurch NICHT verhindert.
  function sha256Hex(blob) {
    var subtle = window.crypto && window.crypto.subtle;
    if (!subtle || typeof subtle.digest !== 'function') return Promise.resolve('');
    return readBuf(blob).then(function (buf) { return subtle.digest('SHA-256', buf); }).then(function (d) {
      var b = new Uint8Array(d), h = '';
      for (var i = 0; i < b.length; i++) h += (b[i] < 16 ? '0' : '') + b[i].toString(16);
      return h;
    }).catch(function () { return ''; });
  }
  // sichtbare Properties werden im Warenkorb des Themes ungefiltert ausgegeben → keine spitzen Klammern
  // Druck-PNG: Weiß/fast Weiß transparent machen (ein Durchlauf über getImageData/putImageData).
  // min(R,G,B) ≥ 245 → Alpha 0; 235 < min < 245 → Alpha linear auf 0 abgeblendet (keine harten Kanten);
  // darunter unverändert – Grautöne (z. B. RGB 200) werden gedruckt.
  var KNOCK_HI = 245, KNOCK_LO = 235;
  function knockOutWhite(ctx, w, h) {
    var im = ctx.getImageData(0, 0, w, h), d = im.data, changed = 0;
    for (var i = 0; i < d.length; i += 4) {
      var a = d[i + 3];
      if (!a) continue;
      var m = d[i] < d[i + 1] ? d[i] : d[i + 1];
      if (d[i + 2] < m) m = d[i + 2];
      if (m <= KNOCK_LO) continue;
      d[i + 3] = m >= KNOCK_HI ? 0 : Math.round(a * (KNOCK_HI - m) / (KNOCK_HI - KNOCK_LO));
      changed++;
    }
    if (changed) ctx.putImageData(im, 0, 0);
    return changed;
  }
  function safeVisible(v) { return String(v).replace(/</g, '‹').replace(/>/g, '›'); }
  function makeCanvas(w, h) {
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w));
    c.height = Math.max(1, Math.round(h));
    return c;
  }

  // ------------------------------------------------------------------ Dateiprüfung
  function bytesStartWith(b, arr, off) {
    off = off || 0;
    for (var i = 0; i < arr.length; i++) if (b[off + i] !== arr[i]) return false;
    return true;
  }
  function ascii(b, from, to) {
    var s = '';
    for (var i = from; i < Math.min(to, b.length); i++) s += String.fromCharCode(b[i]);
    return s;
  }
  // liefert 'png' | 'jpeg' | 'heic' | 'avif' | 'svg' | 'pdf' | 'webp' | 'gif' | 'unknown'
  function sniffType(b) {
    if (bytesStartWith(b, [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a])) return 'png';
    if (bytesStartWith(b, [0xff, 0xd8, 0xff])) return 'jpeg';
    if (ascii(b, 4, 8) === 'ftyp') {
      var brand = ascii(b, 8, 12).toLowerCase();
      if (brand === 'avif' || brand === 'avis') return 'avif';
      return 'heic'; // heic, heix, hevc, heim, heis, mif1, msf1 …
    }
    if (ascii(b, 0, 4) === '%PDF') return 'pdf';
    if (ascii(b, 0, 4) === 'RIFF' && ascii(b, 8, 12) === 'WEBP') return 'webp';
    if (ascii(b, 0, 4) === 'GIF8') return 'gif';
    var head = ascii(b, 0, Math.min(b.length, 512)).replace(/^﻿/, '').trim().toLowerCase();
    if (head.indexOf('<svg') !== -1 || (head.indexOf('<?xml') === 0 && head.indexOf('svg') !== -1)) return 'svg';
    return 'unknown';
  }
  function typeFromNameMime(file) {
    var n = (file.name || '').toLowerCase();
    var m = (file.type || '').toLowerCase();
    if (/\.(heic|heif)$/.test(n) || /heic|heif/.test(m)) return 'heic';
    if (/\.svgz?$/.test(n) || m === 'image/svg+xml') return 'svg';
    if (/\.pdf$/.test(n) || m === 'application/pdf') return 'pdf';
    if (/\.webp$/.test(n) || m === 'image/webp') return 'webp';
    if (/\.gif$/.test(n) || m === 'image/gif') return 'gif';
    if (/\.avif$/.test(n) || m === 'image/avif') return 'avif';
    if (/\.png$/.test(n) || m === 'image/png') return 'png';
    if (/\.(jpe?g|jfif|jpe)$/.test(n) || m === 'image/jpeg' || m === 'image/jpg') return 'jpeg';
    return '';
  }
  // EXIF-Orientierung + Rohmaße aus JPEG lesen
  function readJpegInfo(buf) {
    var v = new DataView(buf);
    var info = { orientation: 1, width: 0, height: 0 };
    if (v.byteLength < 4 || v.getUint16(0) !== 0xffd8) return info;
    var off = 2;
    while (off + 4 <= v.byteLength) {
      if (v.getUint8(off) !== 0xff) break;
      var marker = v.getUint8(off + 1);
      if (marker === 0xd9 || marker === 0xda) break;
      var len = v.getUint16(off + 2);
      if (marker === 0xe1 && off + 10 < v.byteLength && v.getUint32(off + 4) === 0x45786966) {
        var tiff = off + 10;
        var little = v.getUint16(tiff) === 0x4949;
        var ifd = tiff + v.getUint32(tiff + 4, little);
        if (ifd + 2 <= v.byteLength) {
          var n = v.getUint16(ifd, little);
          for (var i = 0; i < n; i++) {
            var e = ifd + 2 + i * 12;
            if (e + 10 > v.byteLength) break;
            if (v.getUint16(e, little) === 0x0112) info.orientation = v.getUint16(e + 8, little) || 1;
          }
        }
      } else if ((marker >= 0xc0 && marker <= 0xc3) || (marker >= 0xc5 && marker <= 0xc7) || (marker >= 0xc9 && marker <= 0xcb) || (marker >= 0xcd && marker <= 0xcf)) {
        if (off + 9 <= v.byteLength) {
          info.height = v.getUint16(off + 5);
          info.width = v.getUint16(off + 7);
        }
      }
      off += 2 + len;
    }
    return info;
  }
  function loadImageFromBlob(blob) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(blob);
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () { resolve({ img: img, url: url }); };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
      img.src = url;
    });
  }
  // Fix r3 (T5 r3): deterministische Verkleinerung (Flächenmittel, vormultipliziertes Alpha) statt drawImage-Glättung. Chromium und
  // WebKit verkleinern feine helle Linien verschieden (Chromium behält 1-px-Linien in voller Stärke, WebKit mittelt sie weg) → Zuschnitt,
  // Hinweis und Auto-Größe großer Bilder (> MAX_WORK_PX) hingen von der Engine ab. Die Quelle wird streifenweise 1:1 gelesen
  // (≤ STREIFEN_PX Pixel je Streifen, eine Streifen-Leinwand), Zielzeile/-spalte = Mittel über die überdeckte Quellfläche.
  var STREIFEN_PX = 4194304;
  function flaecheVerkleinern(img, w, h, tw, th) {
    var fx = w / tw, fy = h / th, flaeche = fx * fy, n4 = tw * 4, dx, k;
    var xa = new Int32Array(tw), xb = new Int32Array(tw), wa = new Float64Array(tw), wb = new Float64Array(tw);
    for (dx = 0; dx < tw; dx++) {
      var s0 = dx * fx, s1 = Math.min(w, (dx + 1) * fx);
      xa[dx] = Math.floor(s0); xb[dx] = Math.max(xa[dx], Math.min(w - 1, Math.ceil(s1) - 1));
      wa[dx] = Math.min(s1, xa[dx] + 1) - s0;   // Anteil der ersten Quellspalte
      wb[dx] = s1 - Math.max(s0, xb[dx]);       // Anteil der letzten (bei xa = xb ungenutzt)
    }
    var out = makeCanvas(tw, th), ox = out.getContext('2d'), od = ox.createImageData(tw, th), o = od.data;
    var zeile = new Float64Array(n4), acc = new Float64Array(n4);
    var band = Math.max(1, Math.min(h, Math.floor(STREIFEN_PX / w)));
    var bc = makeCanvas(w, band), bx = bc.getContext('2d', { willReadFrequently: true });
    bx.imageSmoothingEnabled = false; // 1:1-Kopie der Quellpixel
    var dy = 0;
    function zeileFertig() {
      var base = dy * n4;
      for (var q = 0; q < n4; q += 4) {
        var A = acc[q + 3];
        if (A > 0) {
          o[base + q] = Math.round(acc[q] / A); o[base + q + 1] = Math.round(acc[q + 1] / A); o[base + q + 2] = Math.round(acc[q + 2] / A);
          o[base + q + 3] = Math.min(255, Math.round(A / flaeche));
        }
        acc[q] = acc[q + 1] = acc[q + 2] = acc[q + 3] = 0;
      }
      dy++;
    }
    for (var y0 = 0; y0 < h; y0 += band) {
      var bh = Math.min(band, h - y0);
      bx.clearRect(0, 0, w, band);
      bx.drawImage(img, 0, y0, w, bh, 0, 0, w, bh);
      var d = bx.getImageData(0, 0, w, bh).data;
      for (var yy = 0; yy < bh; yy++) {
        var sy = y0 + yy, ro = yy * w * 4;
        for (dx = 0; dx < tw; dx++) { // Quellzeile waagerecht auf tw Spalten (Farbe × Alpha)
          var r = 0, g = 0, b = 0, a = 0, x0 = xa[dx], x1 = xb[dx];
          for (var sx = x0; sx <= x1; sx++) {
            var p = ro + sx * 4, al = d[p + 3] * (sx === x0 ? wa[dx] : (sx === x1 ? wb[dx] : 1));
            r += d[p] * al; g += d[p + 1] * al; b += d[p + 2] * al; a += al;
          }
          k = dx * 4; zeile[k] = r; zeile[k + 1] = g; zeile[k + 2] = b; zeile[k + 3] = a;
        }
        var t0 = sy; // Quellzeile [sy, sy + 1) auf die Zielzeilen verteilen
        while (dy < th && t0 < sy + 1) {
          var grenze = (dy + 1) * fy, ende = Math.min(sy + 1, grenze), wv = ende - t0;
          if (wv > 0) for (k = 0; k < n4; k++) acc[k] += zeile[k] * wv;
          t0 = ende;
          if (grenze <= sy + 1 + 1e-9) zeileFertig(); else break;
        }
      }
    }
    while (dy < th) zeileFertig(); // Rundungsrest der letzten Zeile
    ox.putImageData(od, 0, 0);
    bc.width = bc.height = 1;
    return out;
  }
  // Bild (ggf. EXIF manuell drehen) auf max. 2048 px verkleinern
  function toWorkingCanvas(img, orientation, manual) {
    var w = img.naturalWidth, h = img.naturalHeight;
    var rot = manual && orientation >= 5 && orientation <= 8;
    var ow = rot ? h : w, oh = rot ? w : h;
    var scale = Math.min(1, MAX_WORK_PX / Math.max(ow, oh));
    var src = img, sw = w, sh = h, fl = null;
    // Fix r3: deterministisch verkleinern (flaecheVerkleinern); bisheriger Browser-Weg nur bei Fehler oder Übergröße (> 16384 px)
    if (scale < 1 && w <= 16384 && h <= 16384) {
      var fw = Math.max(1, Math.round(w * scale)), fh = Math.max(1, Math.round(h * scale));
      try { fl = flaecheVerkleinern(img, w, h, fw, fh); } catch (e) { fl = null; if (window.console) console.warn('[rlg-perso] Verkleinern:', e); }
      if (fl && !(manual && orientation > 1)) return { canvas: fl, origW: ow, origH: oh };
      if (fl) { src = fl; sw = fw; sh = fh; scale = 1; } // EXIF-Drehung danach 1:1
    }
    // stufenweise halbieren für saubere Verkleinerung
    while (Math.max(sw, sh) * scale < Math.max(sw, sh) / 2.2) {
      var hf = 0.5;
      if (sw * sh * hf * hf > MAX_CANVAS_AREA) hf = Math.sqrt(MAX_CANVAS_AREA * 0.95 / (sw * sh));
      var hw = Math.round(sw * hf), hh = Math.round(sh * hf);
      var hc = makeCanvas(hw, hh);
      var hx = hc.getContext('2d');
      hx.imageSmoothingQuality = 'high';
      hx.drawImage(src, 0, 0, hw, hh);
      scale = scale * (sw / hw);
      src = hc; sw = hw; sh = hh;
    }
    var tw = Math.max(1, Math.round(sw * scale)), th = Math.max(1, Math.round(sh * scale));
    var cw = rot ? th : tw, ch = rot ? tw : th;
    var c = makeCanvas(cw, ch);
    var x = c.getContext('2d');
    x.imageSmoothingQuality = 'high';
    if (manual && orientation > 1) {
      switch (orientation) {
        case 2: x.transform(-1, 0, 0, 1, cw, 0); break;
        case 3: x.transform(-1, 0, 0, -1, cw, ch); break;
        case 4: x.transform(1, 0, 0, -1, 0, ch); break;
        case 5: x.transform(0, 1, 1, 0, 0, 0); break;
        case 6: x.transform(0, 1, -1, 0, cw, 0); break;
        case 7: x.transform(0, -1, -1, 0, cw, ch); break;
        case 8: x.transform(0, -1, 1, 0, 0, ch); break;
      }
    }
    x.drawImage(src, 0, 0, tw, th);
    return { canvas: c, origW: ow, origH: oh };
  }
  // Transparenz/Hintergrund prüfen, Motiv auf druckbaren Inhalt zuschneiden
  // Fix r1 (T2 m06): hellWeiss = true/false erzwingt den Rausch-Modus (vollAusschnitt übernimmt ihn vom ersten Durchgang);
  // undefined = am Rand erkennen. Rausch-Modus: Der Rand (3 %) ist deckend, überwiegend Weiß (≥ 240) mit verstreuten hellgrauen,
  // ungesättigten Pixeln (min ≥ HELL_MIN, max − min ≤ HELL_SAT), sonst nichts. Dann zählen vereinzelte solche Pixel beim Zuschnitt als
  // Hintergrund (Fix r2: rauschBox) – sonst legt JPEG-/Scan-Rauschen am Bildrand die Auto-Größe fest (Logo bis ~50 % kleiner). Pixel bleiben unverändert.
  var HELL_MIN = 220, HELL_SAT = 24;
  // Fix r2 (T5 Q1): Im Rausch-Modus fallen nur kleine, vereinzelte hellgraue Gruppen (8er-Nachbarschaft) aus dem Zuschnitt – sonst
  // fehlten hellgraue Bänder, Claims oder Logos im Druck (Knockout erst ab min RGB 235, sie würden gedruckt). Gruppen ab RAUSCH_MIN_PX
  // bzw. RAUSCH_MIN_ANTEIL der Bildfläche zählen als Motiv (JPEG-Rand-Rauschen m06: größte Gruppe 27 px; Claim-Buchstaben 44 px: ≥ 90 px),
  // kleinere nur, wenn sie höchstens RAUSCH_NAH × kürzere Bildseite vom Motiv entfernt liegen (Punkt am Satzende, feine Schrift),
  // wiederholt bis stabil (höchstens RAUSCH_RUNDEN). Ergebnis [x0, y0, x1, y1] oder null → normaler Zuschnitt (alle Tinte).
  var RAUSCH_MIN_PX = 30, RAUSCH_MIN_ANTEIL = 6e-5, RAUSCH_NAH = 0.02, RAUSCH_RUNDEN = 60;
  function rauschBox(data, w, h, sBox) {
    var n = w * h, m = new Uint8Array(n), i, j, r, g, b, lo, hi;
    for (i = 0; i < n; i++) {
      j = i * 4; r = data[j]; g = data[j + 1]; b = data[j + 2];
      if (data[j + 3] <= 16 || (r >= 240 && g >= 240 && b >= 240)) continue; // keine Tinte (wie analyzeAndTrim)
      lo = r < g ? r : g; hi = r > g ? r : g;
      if (b < lo) lo = b;
      if (b > hi) hi = b;
      if (lo >= HELL_MIN && hi - lo <= HELL_SAT) m[i] = 1; // hellgrau (wie analyzeAndTrim)
    }
    var minGr = Math.max(RAUSCH_MIN_PX, Math.round(n * RAUSCH_MIN_ANTEIL));
    var nah = Math.max(3, Math.round(Math.min(w, h) * RAUSCH_NAH));
    var box = sBox ? sBox.slice() : null, klein = [], st = [];
    function dazu(x0, y0, x1, y1) {
      if (!box) { box = [x0, y0, x1, y1]; return; }
      if (x0 < box[0]) box[0] = x0;
      if (y0 < box[1]) box[1] = y0;
      if (x1 > box[2]) box[2] = x1;
      if (y1 > box[3]) box[3] = y1;
    }
    for (i = 0; i < n; i++) {
      if (!m[i]) continue;
      m[i] = 0; st.push(i);
      var gr = 0, gx0 = w, gy0 = h, gx1 = -1, gy1 = -1;
      while (st.length) {
        var p = st.pop(), px = p % w, py = (p - px) / w;
        gr++;
        if (px < gx0) gx0 = px;
        if (px > gx1) gx1 = px;
        if (py < gy0) gy0 = py;
        if (py > gy1) gy1 = py;
        for (var yy = py - 1; yy <= py + 1; yy++) {
          if (yy < 0 || yy >= h) continue;
          for (var xx = px - 1; xx <= px + 1; xx++) {
            if (xx < 0 || xx >= w) continue;
            var q = yy * w + xx;
            if (m[q]) { m[q] = 0; st.push(q); }
          }
        }
      }
      if (gr >= minGr) dazu(gx0, gy0, gx1, gy1);
      else klein.push(gx0, gy0, gx1, gy1);
    }
    if (!box) return null;
    for (var runde = 0; ; runde++) {
      if (runde >= RAUSCH_RUNDEN) return null; // Kette über das ganze Bild: lieber normal zuschneiden (Motiv eher kleiner, nichts fehlt)
      var neu = false, rest = [];
      for (var k = 0; k < klein.length; k += 4) {
        if (klein[k + 2] >= box[0] - nah && klein[k] <= box[2] + nah && klein[k + 3] >= box[1] - nah && klein[k + 1] <= box[3] + nah) {
          dazu(klein[k], klein[k + 1], klein[k + 2], klein[k + 3]); neu = true;
        } else rest.push(klein[k], klein[k + 1], klein[k + 2], klein[k + 3]);
      }
      klein = rest;
      if (!neu) return box;
    }
  }
  // Fix r3 (T6 r3, T5 r3): Liegt um einen dichten Kern nur dünne oder vereinzelte Tinte (Pünktchen, JPEG-Sprenkel, 1-px-Rahmen/-Ring), legt
  // sie den Zuschnitt und damit die Auto-Größe fest – das Logo wird kleiner. Sie bleibt Motiv (wird gedruckt), der Kunde bekommt t.hint_punkte.
  // Dichter Kern = Box der Tinten-Pixel, deren Umgebung ((2·rr+1)², rr ≈ 1/300 der Zuschnittkante, mind. 2) zu ≥ 45 % aus Tinte besteht
  // (Linien bis ca. 40 % der Fensterbreite und Einzelpunkte sind „dünn“). Hinweis, wenn Zuschnitt-Fläche ≥ PUNKTE_FAKTOR × Kern-Fläche und die
  // Tinte außerhalb des Kerns dünn gesät ist (≤ PUNKTE_DICHTE der Fläche außerhalb). Tinte wie beim Zuschnitt (Alpha > 16, nicht Weiß ≥ 240).
  var PUNKTE_FAKTOR = 1.5, PUNKTE_DICHTE = 0.02, PUNKTE_KERN = 0.45;
  function duenneTinte(data, w, box) {
    var x0 = box[0], y0 = box[1], bw = box[2] - box[0] + 1, bh = box[3] - box[1] + 1, n = bw * bh;
    var rr = Math.max(2, Math.round(Math.max(bw, bh) / 300)), ws = 2 * rr + 1, soll = Math.ceil(PUNKTE_KERN * ws * ws);
    var m = new Uint8Array(n), hs = new Uint8Array(n), x, y, i, j, ink = 0;
    for (y = 0; y < bh; y++) {
      j = ((y + y0) * w + x0) * 4;
      for (x = 0; x < bw; x++, j += 4) {
        if (data[j + 3] > 16 && !(data[j] >= 240 && data[j + 1] >= 240 && data[j + 2] >= 240)) { m[y * bw + x] = 1; ink++; }
      }
    }
    // waagerechte Fenstersumme je Pixel (≤ ws ≤ 255)
    for (y = 0; y < bh; y++) {
      var o = y * bw, run = 0;
      for (x = 0; x <= rr && x < bw; x++) run += m[o + x];
      for (x = 0; x < bw; x++) {
        hs[o + x] = run;
        if (x + rr + 1 < bw) run += m[o + x + rr + 1];
        if (x - rr >= 0) run -= m[o + x - rr];
      }
    }
    // senkrechte Fenstersumme (Spaltensummen, gleitend) → Kern-Box
    var col = new Uint16Array(bw), kx0 = bw, ky0 = bh, kx1 = -1, ky1 = -1, kernInk = 0;
    for (y = 0; y <= rr && y < bh; y++) for (x = 0, i = y * bw; x < bw; x++, i++) col[x] += hs[i];
    for (y = 0; y < bh; y++) {
      for (x = 0, i = y * bw; x < bw; x++, i++) {
        if (m[i] && col[x] >= soll) {
          if (x < kx0) kx0 = x;
          if (x > kx1) kx1 = x;
          if (y < ky0) ky0 = y;
          if (y > ky1) ky1 = y;
        }
      }
      var yn = y + rr + 1, ya = y - rr;
      if (yn < bh) for (x = 0, i = yn * bw; x < bw; x++, i++) col[x] += hs[i];
      if (ya >= 0) for (x = 0, i = ya * bw; x < bw; x++, i++) col[x] -= hs[i];
    }
    if (kx1 < 0) return false; // kein dichter Kern (feine Strichzeichnung): keine Aussage
    var kA = (kx1 - kx0 + 1) * (ky1 - ky0 + 1);
    if (n < PUNKTE_FAKTOR * kA) return false;
    for (y = ky0; y <= ky1; y++) for (x = kx0, i = y * bw + kx0; x <= kx1; x++, i++) kernInk += m[i];
    if ((ink - kernInk) / (n - kA) > PUNKTE_DICHTE) return false;
    // Fix r4: Kern-Box (Pixel des RGBA-Felds, inklusive) für den Kern-Zuschnitt auf Wunsch; rr = Fensterradius (Randzugabe beim Zuschnitt)
    return { x0: x0 + kx0, y0: y0 + ky0, x1: x0 + kx1, y1: y0 + ky1, rr: rr };
  }
  function analyzeAndTrim(canvas, hellWeiss, ohneKern) {
    var w = canvas.width, h = canvas.height;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    var data = ctx.getImageData(0, 0, w, h).data;
    var transparent = 0, total = w * h;
    var minX = w, minY = h, maxX = -1, maxY = -1;
    var sMinX = w, sMinY = h, sMaxX = -1, sMaxY = -1; // Zuschnitt ohne hellgraue Pixel (Rausch-Modus)
    var border = 0, borderWhite = 0, borderTransp = 0, borderHell = 0, borderAndere = 0;
    var bw = Math.max(1, Math.round(Math.min(w, h) * 0.03));
    for (var y = 0; y < h; y++) {
      var isBy = y < bw || y >= h - bw;
      for (var x = 0; x < w; x++) {
        var i = (y * w + x) * 4;
        var a = data[i + 3];
        var white = data[i] >= 240 && data[i + 1] >= 240 && data[i + 2] >= 240;
        var lo = data[i] < data[i + 1] ? data[i] : data[i + 1], hi = data[i] > data[i + 1] ? data[i] : data[i + 1];
        if (data[i + 2] < lo) lo = data[i + 2];
        if (data[i + 2] > hi) hi = data[i + 2];
        var hell = !white && lo >= HELL_MIN && hi - lo <= HELL_SAT;
        if (a < 250) transparent++;
        var ink = a > 16 && !white;
        if (ink) {
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
          if (!hell) {
            if (x < sMinX) sMinX = x;
            if (x > sMaxX) sMaxX = x;
            if (y < sMinY) sMinY = y;
            if (y > sMaxY) sMaxY = y;
          }
        }
        if (isBy || x < bw || x >= w - bw) {
          border++;
          if (a < 250) borderTransp++;
          else if (white) borderWhite++;
          else if (hell) borderHell++;
          else borderAndere++;
        }
      }
    }
    // überwiegend Weiß (≥ 50 %) mit Flecken: ein gleichmäßig hellgrauer Hintergrund (z. B. #eee) bleibt wie bisher (wird gedruckt, Hinweis)
    var rauschen = hellWeiss === true || (hellWeiss !== false && border > 0 && borderHell / border >= 0.005 &&
      borderAndere / border <= 0.002 && borderWhite / border >= 0.5 && (borderWhite + borderHell) / border >= 0.9);
    var rauschWeg = false;
    if (rauschen) {
      // Fix r2: nur vereinzelte hellgraue Gruppen ausnehmen (rauschBox); nichts übrig → normaler Zuschnitt (alle Tinte)
      var rb = rauschBox(data, w, h, sMaxX >= 0 ? [sMinX, sMinY, sMaxX, sMaxY] : null);
      // Fix r3: t.hint_rand („lassen wir weg“) nur, wenn der Zuschnitt dadurch wirklich kleiner wurde
      if (rb) { rauschWeg = rb[0] > minX || rb[1] > minY || rb[2] < maxX || rb[3] < maxY; minX = rb[0]; minY = rb[1]; maxX = rb[2]; maxY = rb[3]; }
    }
    var res = {
      hasTransparency: transparent / total > 0.005,
      whiteBackground: border > 0 && (borderWhite + (rauschen ? borderHell : 0)) / border > 0.85,
      transparentBorder: border > 0 && borderTransp / border > 0.5,
      rauschen: rauschen,
      rauschWeg: rauschWeg,
      punkte: false,
      empty: maxX < 0,
      canvas: canvas
    };
    // Fix r3 (T6 r3): verstreute/dünne Tinte vergrößert den Zuschnitt deutlich → bleibt im Motiv (wird gedruckt), nur Hinweis t.hint_punkte
    if (!res.empty && !ohneKern) {
      var kb = null;
      try { kb = duenneTinte(data, w, [minX, minY, maxX, maxY]); } catch (e) { kb = null; }
      res.punkte = !!kb;
      res.kern = kb || null; // Fix r4: Kern-Box für den Zuschnitt auf Wunsch
    }
    if (!res.empty) {
      // ohne Zusatzrand: die Motivbreite (_Groesse_mm) entspricht damit der gedruckten Breite
      var tw = maxX - minX + 1, th = maxY - minY + 1;
      res.box = { x: minX, y: minY, w: tw, h: th };
      if (tw < w || th < h) {
        var t = makeCanvas(tw, th);
        t.getContext('2d').drawImage(canvas, minX, minY, tw, th, 0, 0, tw, th);
        res.canvas = t;
      }
    }
    return res;
  }

  // 09.10.2026: großes Bild (Arbeitsfläche verkleinert) mit kleinem Motiv → Motiv in Originalauflösung ausschneiden.
  // Nur ohne manuelle EXIF-Drehung (Bildmaße = Arbeitsmaße der Ausrichtung) und wenn der Ausschnitt ≤ MAX_WORK_PX ist; sonst null.
  function vollAusschnitt(img, work, an, manual) {
    var nw = img.naturalWidth, nh = img.naturalHeight, c = work.canvas;
    if (manual || !an.box || nw !== work.origW || nh !== work.origH) return null;
    if (c.width >= nw && c.height >= nh) return null; // nicht verkleinert: Arbeitsfläche hat schon alle Pixel
    var fx = nw / c.width, fy = nh / c.height;
    var sx = Math.max(0, Math.floor((an.box.x - 1) * fx)), sy = Math.max(0, Math.floor((an.box.y - 1) * fy));
    var ex = Math.min(nw, Math.ceil((an.box.x + an.box.w + 1) * fx)), ey = Math.min(nh, Math.ceil((an.box.y + an.box.h + 1) * fy));
    var sw = ex - sx, sh = ey - sy;
    if (sw < 1 || sh < 1 || sw > MAX_WORK_PX || sh > MAX_WORK_PX || sw * sh > MAX_CANVAS_AREA) return null;
    var k = makeCanvas(sw, sh), x = k.getContext('2d');
    x.drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh); // 1:1, ohne Skalierung
    var t = analyzeAndTrim(k, !!an.rauschen, true); // Fix r1: Rausch-Modus vom ersten Durchgang (ohne Rauschen: wie bisher); Fix r3: Hinweis aus dem 1. Durchgang
    if (t.canvas !== k) k.width = k.height = 1; // Fix r5: Rohausschnitt freigeben (das Motiv ist der zugeschnittene Canvas)
    return t.empty ? null : t.canvas;
  }
  // Fix r4: Kern-Zuschnitt auf Wunsch. Kern-Box (an.kern, Arbeitsfläche) + Randzugabe rr + 1 px (Kantenglättung und flache Rundungen am
  // Logo-Rand liegen dort unter der Dichte-Schwelle) ausschneiden – großes Bild wie vollAusschnitt aus dem Original (1:1, ≤ MAX_WORK_PX), sonst
  // aus der Arbeitsfläche –, darin vereinzelte Punkte entfernen (kernSaeubern), neu auf Tinte zuschneiden (Rausch-Modus des ersten Durchgangs).
  // Linien und Punkte außerhalb der Kern-Box fallen durch den Zuschnitt weg. null = kein Kern-Zuschnitt möglich.
  // Fix r5: erst beim ersten Klick (kernBerechnen) aus der neu dekodierten Datei. q = beim Hochladen gemerkt (s.kernQuelle): Kern-Box,
  // Rausch-Modus, EXIF-Ausrichtung/manual, Maße von Original und Arbeitsfläche. Die Arbeitsfläche wird nur gebaut, wenn der Ausschnitt
  // weder 1:1 aus dem Original (großes Bild) noch 1:1 aus dem Bild (nicht verkleinert, ohne manuelle Drehung) kommen kann.
  // Rohausschnitt (roh) und Arbeitsfläche werden danach freigegeben (1 × 1 px), wenn nicht sie das Ergebnis sind.
  function kernAusschnitt(img, q) {
    var k = q && q.kern, cw = q && q.workW, ch = q && q.workH, manual = q && q.manual;
    if (!k || !(cw > 0) || !(ch > 0)) return null;
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (nw !== q.natW || nh !== q.natH) return null; // andere Datei/Dekodierung als beim Hochladen
    var rand = (k.rr || 2) + 1;
    var x0 = Math.max(0, k.x0 - rand), y0 = Math.max(0, k.y0 - rand), x1 = Math.min(cw - 1, k.x1 + rand), y1 = Math.min(ch - 1, k.y1 + rand);
    var box = { x: x0, y: y0, w: x1 - x0 + 1, h: y1 - y0 + 1 };
    if (!(box.w > 0 && box.h > 0)) return null;
    var roh = null;
    if (!manual && nw === q.origW && nh === q.origH && !(cw >= nw && ch >= nh)) {
      var fx = nw / cw, fy = nh / ch;
      var sx = Math.max(0, Math.floor((box.x - 1) * fx)), sy = Math.max(0, Math.floor((box.y - 1) * fy));
      var ex = Math.min(nw, Math.ceil((box.x + box.w + 1) * fx)), ey = Math.min(nh, Math.ceil((box.y + box.h + 1) * fy));
      var sw = ex - sx, sh = ey - sy;
      if (sw >= 1 && sh >= 1 && sw <= MAX_WORK_PX && sh <= MAX_WORK_PX && sw * sh <= MAX_CANVAS_AREA) {
        roh = makeCanvas(sw, sh);
        roh.getContext('2d').drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh); // 1:1 aus dem Original
      }
    }
    if (!roh && !manual && nw === cw && nh === ch) {
      // nicht verkleinert, ohne manuelle Drehung: Arbeitsfläche = Bild 1:1 (toWorkingCanvas zeichnet es unverändert)
      roh = makeCanvas(box.w, box.h);
      roh.getContext('2d').drawImage(img, box.x, box.y, box.w, box.h, 0, 0, box.w, box.h);
    }
    if (!roh) {
      var work = toWorkingCanvas(img, q.orientation, manual), c = work.canvas;
      if (c.width !== cw || c.height !== ch) { c.width = c.height = 1; return null; }
      roh = makeCanvas(box.w, box.h);
      roh.getContext('2d').drawImage(c, box.x, box.y, box.w, box.h, 0, 0, box.w, box.h); // 1:1 aus der Arbeitsfläche
      c.width = c.height = 1;
    }
    try { kernSaeubern(roh); } catch (e) { if (window.console) console.warn('[rlg-perso] Kern säubern:', e); }
    var a = analyzeAndTrim(roh, !!q.rauschen, true);
    if (a.canvas !== roh) roh.width = roh.height = 1; // Fix r5 (T5 r5): Rohausschnitt nicht weiterverwendet → freigeben
    return a.empty ? null : a.canvas;
  }
  // Fix r4: vereinzelte Punkte im Kern-Ausschnitt entfernen (Alpha 0). Tinte = Kriterium der Druck-PNG (tinteAn, nach Knockout). Gruppen
  // (8er-Nachbarschaft) ab RAUSCH_MIN_PX bzw. RAUSCH_MIN_ANTEIL der Fläche sind Motiv; kleinere bleiben, wenn sie höchstens KERN_NAH × kürzere
  // Seite (mind. 3 px) von Motiv-Pixeln entfernt liegen (i-Punkt, Umlaut, Satzzeichen, Kantenreste), sonst fallen sie weg. Keine Motiv-Gruppe:
  // nichts ändern. Liefert die Zahl entfernter Pixel.
  var KERN_NAH = 0.02;
  function kernSaeubern(cv) {
    var w = cv.width, h = cv.height, n = w * h, x = cv.getContext('2d', { willReadFrequently: true });
    var im = x.getImageData(0, 0, w, h), d = im.data, lab = new Int32Array(n), gr = [0], st = [], nr = 0, i, p, px, py, xx, yy, q;
    for (i = 0; i < n; i++) {
      if (lab[i] || !tinteAn(d, i * 4, true)) continue;
      lab[i] = ++nr; st.push(i); var g = 0;
      while (st.length) {
        p = st.pop(); px = p % w; py = (p - px) / w; g++;
        for (yy = py - 1; yy <= py + 1; yy++) {
          if (yy < 0 || yy >= h) continue;
          for (xx = px - 1; xx <= px + 1; xx++) {
            if (xx < 0 || xx >= w) continue;
            q = yy * w + xx;
            if (!lab[q] && tinteAn(d, q * 4, true)) { lab[q] = nr; st.push(q); }
          }
        }
      }
      gr.push(g);
    }
    if (!nr) return 0;
    var minGr = Math.max(RAUSCH_MIN_PX, Math.round(n * RAUSCH_MIN_ANTEIL)), nah = Math.max(3, Math.round(Math.min(w, h) * KERN_NAH));
    var nahe = new Uint8Array(n), zeile = new Uint8Array(n), motiv = false, y, xs, last;
    // waagerecht: Abstand zum nächsten Motiv-Pixel der Zeile ≤ nah (zwei Durchläufe), dann senkrecht auf diesem Ergebnis (Quadrat 2·nah+1)
    for (y = 0; y < h; y++) {
      var o = y * w;
      for (last = -Infinity, xs = 0; xs < w; xs++) { if (lab[o + xs] && gr[lab[o + xs]] >= minGr) { last = xs; motiv = true; } if (xs - last <= nah) zeile[o + xs] = 1; }
      for (last = Infinity, xs = w - 1; xs >= 0; xs--) { if (lab[o + xs] && gr[lab[o + xs]] >= minGr) last = xs; if (last - xs <= nah) zeile[o + xs] = 1; }
    }
    if (!motiv) return 0;
    for (xs = 0; xs < w; xs++) {
      for (last = -Infinity, y = 0; y < h; y++) { if (zeile[y * w + xs]) last = y; if (y - last <= nah) nahe[y * w + xs] = 1; }
      for (last = Infinity, y = h - 1; y >= 0; y--) { if (zeile[y * w + xs]) last = y; if (last - y <= nah) nahe[y * w + xs] = 1; }
    }
    var behalten = new Uint8Array(nr + 1), weg = 0;
    for (i = 1; i <= nr; i++) if (gr[i] >= minGr) behalten[i] = 1;
    for (i = 0; i < n; i++) if (lab[i] && nahe[i]) behalten[lab[i]] = 1;
    for (i = 0; i < n; i++) if (lab[i] && !behalten[lab[i]]) { d[i * 4 + 3] = 0; weg++; }
    if (weg) x.putImageData(im, 0, 0);
    return weg;
  }

  // ------------------------------------------------------------------ Konfigurator
  function Perso(root) {
    this.root = root;
    var cfgEl = $(root, '[data-rp-config]');
    this.cfg = JSON.parse(cfgEl.textContent);
    this.t = this.cfg.t;
    this.formId = this.cfg.formId;
    this.ball = 'PURE';
    this.sides = 1;
    this.active = 0;
    this.code = null;
    this.queue = Promise.resolve();
    this.usedArts = {}; // unter dem aktuellen Code schon hochgeladene Originale (Originale werden nie überschrieben)
    this.allowSubmit = false;
    this.busy = false;
    this.rev = 0; // Revisionszähler: jede Motivänderung (designChanged) zählt hoch, Absenden vergleicht Anfang und Ende (08.10.2026)
    this.view = 'ganz';
    this.side = [this.newSide(), this.newSide()];
    this.ballImg = {};
    this.layoutCache = [null, null];
    this.init();
  }

  Perso.prototype.newSide = function () {
    return {
      file: null, fileName: '', mime: '', img: null, origW: 0, origH: 0,
      origPath: '', origCode: null, origSha: '', uploading: false, uploadPct: 0, uploadFailed: false,
      msgs: [], lines: ['', '', ''],
      font: this.cfg ? this.cfg.fonts[0].id : 'montserrat',
      color: this.cfg ? this.cfg.colors[0].hex : '#111111',
      zoom: 1, rot: 0, x: 0, y: 0,
      // Entweder-oder: gewählte Art; tfArt = Art, deren Größe/Drehung/Position gerade in zoom/rot/x/y steht; tf = Stand der anderen Art
      mode: 'bild', tfArt: 'bild', tf: {},
      // Fix r4: Kern-Zuschnitt auf Wunsch – imgGanz = zugeschnittenes ganzes Bild, imgKern = nur dichter Kern (oder null), kernAn = Kern gilt
      imgGanz: null, imgKern: null, kernAn: false,
      // Fix r5: kernQuelle = was kernBerechnen beim ersten Klick braucht (oder null), kernJob = Berechnung läuft, kernFehler = kein Ausschnitt
      kernQuelle: null, kernJob: null, kernFehler: false
    };
  };

  Perso.prototype.init = function () {
    var self = this, r = this.root;
    this.form = document.getElementById(this.formId);
    this.hasArt = !!$(r, '[data-rp-art]'); // Entweder-oder-Schalter im Markup (07.10.2026)
    this.canvas = $(r, '[data-rp-canvas]');
    this.ctx = this.canvas.getContext('2d');

    // Optionsindizes (Ball / Druck)
    var opts = this.cfg.options || [];
    this.idxBall = opts.indexOf('Ball');
    this.idxDruck = opts.indexOf('Druck');
    var vs = this.cfg.variants || [];
    if (this.idxBall < 0 || this.idxDruck < 0) {
      for (var oi = 0; oi < opts.length; oi++) {
        var vals = vs.map(function (v) { return String(v.options[oi] || ''); }).join('|');
        if (this.idxBall < 0 && /BOLD|PURE/i.test(vals)) this.idxBall = oi;
        if (this.idxDruck < 0 && SIDES_ANY_RE.test(vals)) this.idxDruck = oi;
      }
    }

    this.checkDeadlines();
    this.buildFontsAndColors();
    this.bindUi();
    this.bindTheme();

    ['PURE', 'BOLD'].forEach(function (k) { self.loadBall(k); });
    this.syncFromTheme(true);
    this.loadFonts(); // Fix r5: geladene Schrift → schriftGeladen (invalidate, ggf. Freigabe ab)

    if (this.cfg.paused) this.applyPause();
    this.renderAll();
    if (window.ResizeObserver) {
      new ResizeObserver(function () { self.drawPreview(); }).observe(this.canvas);
    } else {
      window.addEventListener('resize', function () { self.drawPreview(); });
    }
    // Sperre ohne JavaScript erst ganz am Ende entfernen: wirft init vorher, bleibt das Absenden blockiert (fail closed)
    var guard = $(r, '[data-rp-guard]');
    if (guard) guard.parentNode.removeChild(guard);
    // 3D-Vorschau (08.10.2026) erst danach: ein Fehler dort kann die Sperre nicht mehr betreffen
    try { this.d3Init(); } catch (e) { this.d3 = null; if (window.console) console.warn('[rlg-perso] 3D aus:', e); }
  };

  // Fix r5 (T5 r5, WebKit): Ladezustand je Schrift selbst führen (this.fontSt[id] = { zustand: 'laedt' | 'loaded' | 'error', start, p }).
  // 'loaded' nur, wenn ein FontFace der Familie status 'loaded' meldet (WebKit meldet 'error', solange die Datei nach der Blockzeit noch
  // lädt). 'error' erst nach SCHRIFT_FRIST_MS ohne Erfolg. Beides sperrt das Absenden (fontPending true → t.err_schrift), nie Ersatzschrift.
  // Geprüft wird bei jedem Ende von document.fonts.load / FontFace.loaded, bei 'loadingdone' und im Takt (bis zur Frist SCHRIFT_TAKT_MS,
  // danach bis SCHRIFT_BEOBACHTEN_MS seltener – lädt die Datei doch noch, wird sie übernommen). neu = true: nach 'error' erneut versuchen.
  var SCHRIFT_FRIST_MS = 10000, SCHRIFT_TAKT_MS = 250, SCHRIFT_TAKT_SPAET_MS = 1000, SCHRIFT_BEOBACHTEN_MS = 120000;
  Perso.prototype.loadFonts = function (neu) {
    if (!document.fonts || !document.fonts.load || !document.fonts.forEach) return Promise.resolve();
    var self = this;
    this.fontSt = this.fontSt || {};
    if (!this._fontEvt && document.fonts.addEventListener) {
      this._fontEvt = true;
      try { document.fonts.addEventListener('loadingdone', function () { self.schriftPruefen(); }); } catch (e) {}
    }
    return Promise.all(this.cfg.fonts.map(function (f) { return self.loadFont(f, neu); }));
  };
  Perso.prototype.loadFont = function (f, neu) {
    var self = this, st = this.fontSt[f.id];
    if (st && (st.zustand !== 'error' || !neu)) return st.p;
    var nst = { zustand: 'laedt', start: Date.now() };
    nst.p = new Promise(function (res) { nst.fertig = res; });
    this.fontSt[f.id] = nst;
    var pruef = function () { self.schriftPruefen(); };
    try { document.fonts.load(f.weight + ' 40px "' + f.family + '"', 'AÄgÖÜß').then(pruef, pruef); } catch (e) {}
    this.fontFaces(f).forEach(function (face) {
      try { if (face.loaded && face.loaded.then) face.loaded.then(pruef, pruef); } catch (e) {}
    });
    this.schriftPruefen();
    return nst.p;
  };
  Perso.prototype.fontFaces = function (f) {
    var out = [];
    document.fonts.forEach(function (face) { if (String(face.family).replace(/["']/g, '') === f.family) out.push(face); });
    return out;
  };
  Perso.prototype.schriftPruefen = function () {
    if (!this.fontSt) return;
    var self = this, jetzt = Date.now(), neu = [], offen = false, spaet = false;
    this.cfg.fonts.forEach(function (f) {
      var st = self.fontSt[f.id];
      if (!st || st.zustand === 'loaded') return;
      if (self.fontFaces(f).some(function (face) { return face.status === 'loaded'; })) {
        st.zustand = 'loaded'; neu.push(f); st.fertig('loaded'); return;
      }
      if (st.zustand === 'laedt' && jetzt - st.start >= SCHRIFT_FRIST_MS) {
        st.zustand = 'error'; st.fertig('error');
        if (window.console) console.warn('[rlg-perso] Schrift nicht geladen: ' + f.family + ' – Absenden mit dieser Schrift gesperrt');
      }
      if (st.zustand === 'laedt') offen = true;
      else if (jetzt - st.start < SCHRIFT_BEOBACHTEN_MS) spaet = true;
    });
    clearTimeout(this._schriftUhr);
    if (offen || spaet) this._schriftUhr = setTimeout(function () { self.schriftPruefen(); }, offen ? SCHRIFT_TAKT_MS : SCHRIFT_TAKT_SPAET_MS);
    if (neu.length) this.schriftGeladen(neu);
  };
  // Schrift jetzt geladen: hat eine Seite Text in dieser Schrift, war die Vorschau in einer Ersatzschrift → Layouts neu (Auto-Größe hängt
  // an der Schrift, invalidate) und Freigabe-Häkchen ab (designChanged; wie bisher nach t.err_schrift). Sonst nichts (Bild-Layouts bleiben).
  Perso.prototype.schriftGeladen = function (fonts) {
    var self = this, betroffen = false;
    fonts.forEach(function (f) {
      for (var i = 0; i < self.sides; i++) if (self.textLines(i).length && self.fontById(self.side[i].font).id === f.id) betroffen = true;
    });
    if (!betroffen) return;
    this.invalidate();
    this.designChanged();
  };

  // true, solange eine Schrift nicht sicher geladen ist (lädt noch ODER nach der Frist nicht geladen) – dann kein Absenden
  // (Fix r5; bisher galt FontFace.status 'error' als fertig → Ersatzschrift). Ohne Font-Loading-API wie bisher false.
  Perso.prototype.fontPending = function (f) {
    if (!document.fonts || !document.fonts.load || !document.fonts.forEach) return false;
    if (!this.fontSt || !this.fontSt[f.id]) this.loadFonts();
    this.schriftPruefen();
    var st = this.fontSt[f.id];
    return !st || st.zustand !== 'loaded';
  };

  Perso.prototype.loadBall = function (key) {
    var self = this, b = this.cfg.ball[key];
    var img = new Image();
    img.crossOrigin = 'anonymous'; // Shopify-CDN liefert CORS-Header; sonst würde die Vorschau-PNG blockiert
    img.onload = function () { self.ballImg[key] = img; if (self.ball === key) self.drawPreview(); };
    img.onerror = function () { self.ballImg[key] = null; };
    img.src = b.src;
  };

  // ------------------------------------------------------------------ UI aufbauen
  Perso.prototype.buildFontsAndColors = function () {
    var self = this, r = this.root, uid = this.formId;
    var fw = $(r, '[data-rp-fonts]');
    this.cfg.fonts.forEach(function (f, i) {
      var lab = el('label', { 'class': 'rlg-perso__font' });
      // autocomplete="off": keine Formular-Wiederherstellung durch den Browser beim Zurück (08.10.2026, Review)
      var inp = el('input', { type: 'radio', name: 'rp-font-' + uid, value: f.id, autocomplete: 'off' });
      if (i === 0) inp.checked = true;
      var sp = el('span', null, f.label);
      sp.style.fontFamily = '"' + f.family + '", sans-serif';
      sp.style.fontWeight = f.weight;
      lab.appendChild(inp); lab.appendChild(sp);
      fw.appendChild(lab);
    });
    var cw = $(r, '[data-rp-colors]');
    this.cfg.colors.forEach(function (c, i) {
      var lab = el('label', { 'class': 'rlg-perso__color', title: c.label });
      var inp = el('input', { type: 'radio', name: 'rp-color-' + uid, value: c.hex, 'aria-label': c.label, autocomplete: 'off' });
      if (i === 0) inp.checked = true;
      var sp = el('span', { 'aria-hidden': 'true' });
      sp.style.background = c.hex;
      lab.appendChild(inp); lab.appendChild(sp);
      lab.setAttribute('data-rp-color', c.hex);
      lab.setAttribute('data-bold', c.bold ? '1' : '0');
      cw.appendChild(lab);
    });
  };

  Perso.prototype.bindUi = function () {
    var self = this, r = this.root;

    $$(r, '[data-rp-tab]').forEach(function (b) {
      b.addEventListener('click', function () { self.setActive(+b.getAttribute('data-rp-tab')); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = self.sides === 2 ? 1 - self.active : 0;
          self.setActive(n);
          $(r, '[data-rp-tab="' + n + '"]').focus();
        }
      });
    });

    $(r, '[data-rp-file]').addEventListener('change', function (e) {
      var f = e.target.files && e.target.files[0];
      e.target.value = '';
      if (f) self.handleFile(self.active, f);
    });
    $(r, '[data-rp-remove]').addEventListener('click', function () { self.removeImage(self.active); });

    $$(r, '[data-rp-art-opt]').forEach(function (inp) {
      inp.addEventListener('change', function () { if (inp.checked) self.setArt(inp.value); });
      // 08.10.2026: auch der Klick auf die schon markierte Option gilt (kein change, z. B. nach Wiederherstellung durch den Browser)
      inp.addEventListener('click', function () { self.setArt(inp.value); });
    });

    $$(r, '[data-rp-line]').forEach(function (inp) {
      inp.addEventListener('input', function () {
        var i = +inp.getAttribute('data-rp-line');
        var v = inp.value.replace(/[\r\n\t]/g, ' ');
        var fr = filterChars(self.side[self.active].font, v);
        if (fr.removed) self.showTextHint();
        v = fr.removed ? fr.value.replace(/ {2,}/g, ' ') : fr.value;
        if (v.length > MAX_LINE) v = v.slice(0, MAX_LINE);
        if (v !== inp.value) {
          var pos = inp.selectionStart, diff = inp.value.length - v.length;
          inp.value = v;
          try { if (pos != null) inp.setSelectionRange(Math.max(0, pos - diff), Math.max(0, pos - diff)); } catch (e) {}
        }
        self.side[self.active].lines[i] = v;
        // BOLD kennt nur Text: Tippen gilt als Wahl „Text“, damit ein späterer Wechsel zu PURE den Text behält
        if (self.ball === 'BOLD') self.side[self.active].mode = 'text';
        self.changed(true);
      });
    });

    $(r, '[data-rp-fonts]').addEventListener('change', function (e) {
      if (e.target.name && e.target.name.indexOf('rp-font-') === 0) {
        var sd = self.side[self.active], removed = false;
        sd.font = e.target.value;
        sd.lines = sd.lines.map(function (l) { var fr = filterChars(sd.font, l); if (fr.removed) removed = true; return fr.value; });
        if (removed) self.showTextHint();
        self.changed(true);
      }
    });
    $(r, '[data-rp-colors]').addEventListener('change', function (e) {
      if (e.target.name && e.target.name.indexOf('rp-color-') === 0) { self.side[self.active].color = e.target.value; self.changed(false); }
    });

    // 11.10.2026 (kompakt): keine Regler/Knöpfe für Größe, Drehung, Lage mehr (Auto-Größe); alte Seiten: ausblenden, nichts binden
    this.legacyAus();
    var view = $(r, '[data-rp-view]');
    if (view) view.addEventListener('click', function (e) {
      self.view = self.view === 'ganz' ? 'nah' : 'ganz';
      e.currentTarget.setAttribute('aria-pressed', self.view === 'nah' ? 'true' : 'false');
      e.currentTarget.textContent = self.view === 'nah' ? self.t.ganz : self.t.nah;
      self.drawPreview();
      self.d3Ruf('nah', self.view === 'nah');
    });

    // Fix r4: Kern-Zuschnitt auf Wunsch (Knopf unter t.hint_punkte) – schaltet je Seite zwischen ganzem Bild und Kern
    var kern = $(r, '[data-rp-kern]');
    if (kern) kern.addEventListener('click', function () { self.setKern(self.active, !self.side[self.active].kernAn); });

    $$(r, '[data-rp-check]').forEach(function (c) {
      c.addEventListener('change', function () {
        var lab = c.closest('.rlg-perso__check');
        if (lab) lab.classList.remove('is-invalid');
        if (c.getAttribute('data-rp-check') === 'aufloesung') {
          // 09.10.2026: Stand beim Ankreuzen merken – wird das Motiv danach größer (weniger dpi), gilt das Häkchen nicht mehr
          var ack = null;
          if (c.checked) { ack = {}; self.lowResSides().forEach(function (l) { ack[l.idx] = l.dpi; }); }
          self.resAck = ack;
        }
        if (c.getAttribute('data-rp-check') === 'freigabe' && c.checked) self.setStatus('');
        self.hideError();
      });
    });
  };

  // 11.10.2026 (kompakt): Bedienelemente für Größe/Drehung/Lage einer alten, gecachten Seite ausblenden (das JS bindet sie nicht mehr);
  // Canvas nicht mehr fokussierbar, Seite scrollt beim Wischen über der Vorschau (inline, falls noch die alte CSS mit touch-action: none gilt)
  Perso.prototype.legacyAus = function () {
    var r = this.root, cv = this.canvas;
    ['.rlg-perso__range', '[data-rp-center]', '[data-rp-reset]', '[data-rp-bedienung]', '[data-rp-warn]'].forEach(function (sel) {
      $$(r, sel).forEach(function (n) { n.hidden = true; });
    });
    if (cv) {
      cv.removeAttribute('tabindex');
      cv.style.touchAction = 'auto';
      cv.style.cursor = 'default';
    }
  };

  // ------------------------------------------------------------------ Theme-Anbindung
  Perso.prototype.buyButtons = function () {
    return $$(document, 'button[type="submit"][form="' + this.formId + '"], #' + this.formId + ' button[type="submit"]');
  };

  Perso.prototype.bindTheme = function () {
    var self = this;
    // Absenden abfangen, BEVOR der Theme-Handler (am Formular) läuft
    document.addEventListener('submit', function (e) { self.onSubmit(e); }, true);

    // Variantenwahl: Radios/Selects mit form="<id>" und das versteckte id-Feld
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.getAttribute) return;
      // Achtung: form.id ist durch <input name="id"> überschattet → immer getAttribute('id')
      var owner = t.getAttribute('form') || (t.form && t.form.getAttribute('id'));
      if (owner !== self.formId) return;
      if (t.type === 'radio' || t.tagName === 'SELECT' || t.name === 'id') self.syncFromTheme(false);
    });
    if (this.form) {
      this.form.addEventListener('variant:change', function (e) {
        var v = e.detail && e.detail.variant;
        self.syncFromTheme(false, v);
        if (self.cfg.paused) self.applyPause();
        else if (self._locked) {
          // Theme hat den Button gerade nach Verfügbarkeit gesetzt: diesen Stand merken, Sperre halten
          self.buyButtons().forEach(function (b) { b._rpWasDisabled = b.disabled; b.disabled = true; });
        }
      });
    }
    if (window.theme && theme.pubsub && theme.pubsub.subscribe && theme.pubsub.PUB_SUB_EVENTS) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (d) {
        var v = d && d.data && d.data.variant;
        if (v) self.syncFromTheme(false, v);
      });
    }
    // erfolgreich in den Warenkorb → neue Konfiguration bekommt einen neuen Motiv-Code
    document.addEventListener('ajaxProduct:added', function () {
      if (!self.lastSubmitted) return;
      self.lastSubmitted = false;
      self.inFlightUntil = 0;
      $(self.root, '[data-rp-props]').textContent = '';
      self.code = null;
      self.usedArts = {};
      var f = $(self.root, '[data-rp-check="freigabe"]');
      if (f) f.checked = false;
      self.setStatus(self.t.hinzugefuegt);
    });
    document.addEventListener('ajaxProduct:error', function () {
      if (!self.lastSubmitted) return;
      self.lastSubmitted = false;
      self.inFlightUntil = 0;
      $(self.root, '[data-rp-props]').textContent = '';
    });
    // Zurück/Vor: Der Browser kann Formularfelder nach dem Start wiederherstellen, ohne change → Stand aus dem JS neu zeichnen (08.10.2026)
    window.addEventListener('pageshow', function () { self.inFlightUntil = 0; self.lastSubmitted = false; self.renderSide(); });
  };

  Perso.prototype.currentVariant = function () {
    var inp = this.form && this.form.querySelector('[name="id"]');
    var id = inp ? +inp.value : +this.cfg.selectedVariantId;
    var vs = this.cfg.variants || [];
    for (var i = 0; i < vs.length; i++) if (+vs[i].id === id) return vs[i];
    return vs[0] || null;
  };

  Perso.prototype.syncFromTheme = function (initial, variantFromEvent) {
    var ballVal = '', druckVal = '';
    var opts = this.cfg.options || [];
    // 1. aktuell markierte Optionen (sofort, ohne Server-Antwort)
    var self = this;
    var checked = $$(document, 'input[type="radio"][form="' + this.formId + '"]:checked, select[form="' + this.formId + '"]');
    checked.forEach(function (c) {
      var name = String(c.name || '').replace(/^options\[(.*)\]$/, '$1'), val = c.value;
      if (self.idxBall >= 0 && name === opts[self.idxBall]) ballVal = val;
      if (self.idxDruck >= 0 && name === opts[self.idxDruck]) druckVal = val;
    });
    // 2. sonst Variante (Event oder verstecktes id-Feld)
    var v = variantFromEvent || this.currentVariant();
    if (v && v.options) {
      if (!ballVal && this.idxBall >= 0) ballVal = v.options[this.idxBall];
      if (!druckVal && this.idxDruck >= 0) druckVal = v.options[this.idxDruck];
    }
    var ball = /BOLD/i.test(ballVal || '') ? 'BOLD' : 'PURE';
    var sides = SIDES_TWO_RE.test(druckVal || '') ? 2 : 1;
    var changed = ball !== this.ball || sides !== this.sides;
    this.ball = ball;
    this.sides = sides;
    var aktivVorher = this.active;
    if (this.active >= sides) this.active = 0;
    if (this.active !== aktivVorher) this.d3Ruf('seite', this.active);   // 3D (09.10.2026): Kamera folgt, wenn der Wechsel die Seite zurücksetzt
    if (changed || initial) {
      if (ball === 'BOLD') {
        var self2 = this;
        this.side.forEach(function (s) {
          var ok = self2.cfg.colors.some(function (c) { return c.bold && c.hex === s.color; });
          if (!ok) s.color = self2.cfg.colors[0].hex;
        });
      }
      this.layoutCache = [null, null];
      this.renderAll();
      if (!initial) this.designChanged();
    }
  };

  // Passt die Variante im Formular (verstecktes id-Feld, maßgeblich für den Preis) zu Ball/Seiten der Gestaltung?
  // Das Theme aktualisiert das id-Feld erst nach einem Server-Abruf; bis dahin zeigen die Radios schon die neue Auswahl.
  Perso.prototype.variantConsistent = function () {
    var inp = this.form && this.form.querySelector('[name="id"]');
    if (!inp) return false;
    var id = +inp.value, v = null, vs = this.cfg.variants || [];
    for (var i = 0; i < vs.length; i++) if (+vs[i].id === id) v = vs[i];
    if (!v || !v.options) return false;
    var ball = /BOLD/i.test(v.options[this.idxBall] || '') ? 'BOLD' : 'PURE';
    var sides = SIDES_TWO_RE.test(v.options[this.idxDruck] || '') ? 2 : 1;
    return ball === this.ball && sides === this.sides;
  };

  Perso.prototype.applyPause = function () {
    var self = this;
    var pause = $(this.root, '[data-rp-pause]');
    pause.hidden = false;
    $(this.root, '[data-rp-body]').hidden = true;
    this.buyButtons().forEach(function (b) {
      b.disabled = true;
      b.setAttribute('aria-disabled', 'true');
      if (!b._rpObserved && window.MutationObserver) {
        b._rpObserved = true;
        new MutationObserver(function () {
          if (self.cfg.paused && !b.disabled) b.disabled = true;
        }).observe(b, { attributes: true, attributeFilter: ['disabled'] });
      }
    });
  };

  // ------------------------------------------------------------------ Datei-Upload
  Perso.prototype.handleFile = function (idx, file) {
    var self = this, s = this.side[idx], t = this.t;
    if (this.ball === 'BOLD' || this.artOf(idx) === 'text') return;
    var msgs = [];
    var nameType = typeFromNameMime(file);
    var refuse = { heic: t.err_heic, avif: t.err_typ, svg: t.err_svg, pdf: t.err_pdf, webp: t.err_webp, gif: t.err_gif };
    function fail(m) {
      s.msgs = [{ type: 'error', text: m }];
      if (s.img) s.msgs.push({ type: 'info', text: fill(t.hint_bild_bleibt, { name: s.fileName }) });
      // Fix r4: bleibt das bisherige Bild mit Kern-Zuschnitt-Möglichkeit, bleiben Hinweis und Knopf (sonst käme man nicht zurück)
      if (s.img && (s.imgKern || s.kernQuelle) && t.hint_punkte) s.msgs.push({ type: 'warn', text: t.hint_punkte, punkte: true });
      self.renderSide();
    }
    if (refuse[nameType]) return fail(refuse[nameType]);
    if (file.size > MAX_BYTES) return fail(t.err_gross);
    if (!file.size) return fail(t.err_lesen);

    readBuf(file.slice(0, 512)).then(function (head) {
      var type = sniffType(new Uint8Array(head));
      if (refuse[type]) throw { msg: refuse[type] };
      if (type !== 'png' && type !== 'jpeg') throw { msg: t.err_typ };
      var mime = type === 'png' ? 'image/png' : 'image/jpeg';
      var infoP = type === 'jpeg' ? readBuf(file.slice(0, Math.min(file.size, 262144))).then(readJpegInfo) : Promise.resolve({ orientation: 1 });
      return infoP.then(function (info) {
        return loadImageFromBlob(file).then(function (res) { return { res: res, info: info, mime: mime, type: type }; });
      });
    }).then(function (o) {
      var img = o.res.img, info = o.info;
      var supportsOrientation = window.CSS && CSS.supports && CSS.supports('image-orientation', 'from-image');
      var swapped = info.orientation >= 5 && info.width && info.width !== info.height && img.naturalWidth === info.height && img.naturalHeight === info.width;
      var manual = info.orientation > 1 && (!supportsOrientation || (info.orientation >= 5 && info.width && info.width !== info.height && !swapped));
      var work = toWorkingCanvas(img, info.orientation, manual);
      URL.revokeObjectURL(o.res.url);
      var w = work.origW, h = work.origH;
      if (w < MIN_PX || h < MIN_PX) throw { msg: fill(t.err_klein, { w: w, h: h }) };
      var an = analyzeAndTrim(work.canvas);
      if (an.empty) throw { msg: t.err_leerbild };
      // Auflösungshinweis seit 09.10.2026 live in renderSide (resInfo), abhängig von Größe und Pixeln ohne Rand
      var voll = vollAusschnitt(img, work, an, manual);
      if (voll) an.canvas = voll;
      // Fix r3: verstreute/dünne Tinte vergrößert den Zuschnitt → t.hint_punkte (statt Weiß-/Rand-Hinweis); t.hint_rand nur, wenn etwas wegfiel
      var punkte = an.punkte && t.hint_punkte;
      // Fix r4: Kern-Zuschnitt auf Wunsch – nur mit Hinweis, Knopf im Markup und beiden Knopftexten (altes Snippet: nichts)
      // Fix r5: berechnet wird er erst beim ersten Klick (kernBerechnen); hier nur merken, was dafür nötig ist
      var kernQ = null;
      if (punkte && an.kern && t.kern_an && t.kern_aus && $(self.root, '[data-rp-kern]')) {
        kernQ = { kern: an.kern, rauschen: !!an.rauschen, orientation: info.orientation, manual: manual, origW: work.origW, origH: work.origH,
          workW: work.canvas.width, workH: work.canvas.height, natW: img.naturalWidth, natH: img.naturalHeight };
      }
      if (an.canvas !== work.canvas) work.canvas.width = work.canvas.height = 1; // Fix r5: Arbeitsfläche wird nicht mehr gebraucht
      if (an.hasTransparency) msgs.push({ type: 'ok', text: t.hint_transparent });
      else if (punkte && (an.whiteBackground || an.rauschen)) { /* t.hint_punkte unten */ }
      else if (an.rauschen && an.rauschWeg && t.hint_rand) msgs.push({ type: 'warn', text: t.hint_rand }); // Fix r1: grau-fleckiger Hintergrund
      else if (an.whiteBackground) msgs.push({ type: 'info', text: t.hint_weiss });
      else msgs.push({ type: 'warn', text: t.hint_hintergrund });
      if (punkte) msgs.push({ type: 'warn', text: t.hint_punkte, punkte: true }); // Fix r4: als letzte Meldung, direkt darunter der Knopf
      if (o.type === 'jpeg' && !an.whiteBackground) msgs.push({ type: 'info', text: t.hint_foto });

      s.file = file; s.fileName = file.name || ((t.datei_basis || 'bild') + (o.type === 'png' ? '.png' : '.jpg')); s.mime = o.mime;
      s.img = an.canvas; s.origW = w; s.origH = h;
      s.imgGanz = an.canvas; s.imgKern = null; s.kernAn = false; // Fix r4: neues Bild → ganzes Bild
      s.kernQuelle = kernQ; s.kernJob = null; s.kernFehler = false; // Fix r5
      s.imgGen = (self.imgGen = (self.imgGen || 0) + 1); // jedes neue Bild: viertes Häkchen neu bestätigen (sig in updateResCheck)
      s.origCode = null; s.origPath = ''; s.origSha = ''; s.uploadFailed = false;
      // 08.10.2026 (Review): Wurde während der Verarbeitung auf Text (oder BOLD) gewechselt, steht in zoom/rot/x/y der Stand
      // des Textes → dann nur den Bild-Stand zurücksetzen (gilt beim Rückwechsel), sonst wie bisher
      if (s.tfArt === 'bild') { s.zoom = 1; s.rot = 0; s.x = 0; s.y = 0; }
      else s.tf.bild = { zoom: 1, rot: 0, x: 0, y: 0 };
      // Datensparsamkeit: Original nur hochladen, wenn das Bild gerade gilt; sonst holt die Vorbereitung es bei Bedarf nach
      var gilt = self.artOf(idx) !== 'text';
      if (!gilt) { s.uploading = false; s.uploadPct = 0; }
      s.msgs = msgs;
      self.layoutCache[idx] = null;
      self.changed(true);
      if (gilt) self.startOriginalUpload(idx);
      else self.updateLock();
    }).catch(function (e) {
      fail(e && e.msg ? e.msg : t.err_lesen);
    });
  };

  Perso.prototype.removeImage = function (idx) {
    var s = this.side[idx];
    s.file = null; s.img = null; s.fileName = ''; s.msgs = []; s.origPath = ''; s.origCode = null; s.origSha = '';
    s.uploading = false; s.uploadFailed = false;
    s.imgGanz = null; s.imgKern = null; s.kernAn = false; // Fix r4
    s.kernQuelle = null; s.kernJob = null; s.kernFehler = false; // Fix r5
    this.layoutCache[idx] = null;
    this.changed(true);
    this.updateLock();
  };

  Perso.prototype.enqueue = function (fn) {
    var p = this.queue.then(fn);
    this.queue = p.catch(function () {});
    return p;
  };

  Perso.prototype.sign = function (art, contentType, size) {
    var self = this;
    var body = { art: art, contentType: contentType, size: size };
    if (this.code) body.code = this.code;
    var fresh = !this.code;
    return fetch(this.cfg.uploadUrl, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body),
      credentials: 'omit'
    }).catch(function () { throw new Error(self.t.err_netz); }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || !j || j.error) {
          // Server-Texte sind deutsch: in anderen Sprachen die eigene Meldung zum Grund (sonst allgemeiner Upload-Fehler)
          var msg = (self.cfg.lang && self.cfg.lang !== 'de')
            ? ((j && j.grund && self.t['grund_' + j.grund]) || self.t.upload_fehler)
            : ((j && j.error) || self.t.upload_fehler);
          var err = new Error(msg);
          err.grund = (j && j.grund) || ''; err.status = r.status;
          throw err;
        }
        if (!CODE_RE.test(j.code || '') || !j.signedUrl || !j.path) throw new Error(self.t.upload_fehler);
        if (self.code && self.code !== j.code) throw new Error(self.t.upload_fehler);
        self.code = j.code;
        if (fresh) self.usedArts = {};
        return j;
      });
    });
  };

  // PUT per XHR (Fortschritt), Body = Datei
  Perso.prototype.put = function (signedUrl, blob, contentType, upsert, onProgress) {
    var self = this;
    var url = /^https?:\/\//.test(signedUrl) ? signedUrl : this.cfg.storageBase.replace(/\/$/, '') + (signedUrl.charAt(0) === '/' ? '' : '/') + signedUrl;
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('PUT', url, true);
      x.setRequestHeader('content-type', contentType);
      if (upsert) x.setRequestHeader('x-upsert', 'true');
      if (onProgress && x.upload) {
        x.upload.onprogress = function (e) { if (e.lengthComputable) onProgress(e.loaded / e.total); };
      }
      x.onload = function () {
        if (x.status >= 200 && x.status < 300) resolve();
        else {
          var m = self.t.upload_fehler;
          try { var j = JSON.parse(x.responseText); if (j && (j.error || j.message)) m = self.t.upload_fehler; } catch (e) {}
          reject(new Error(m));
        }
      };
      x.onerror = function () { reject(new Error(self.t.err_netz)); };
      x.send(blob);
    });
  };

  Perso.prototype.uploadOriginalNow = function (idx, retried) {
    var self = this, s = this.side[idx];
    if (!s.file) return Promise.resolve();
    if (s.origCode && s.origCode === this.code && s.origPath) return Promise.resolve();
    var file = s.file, art = 'original-' + (idx + 1);
    // Original dieser Seite gibt es unter dem Code schon (Bild ersetzt) → neuer Motiv-Code statt Überschreiben
    if (this.code && this.usedArts[art]) this.code = null;
    s.uploading = true; s.uploadPct = 0; s.uploadFailed = false;
    this.renderSide();
    this.updateLock();
    return this.sign(art, s.mime, file.size).then(function (j) {
      return self.put(j.signedUrl, file, s.mime, false, function (p) {
        s.uploadPct = p; if (idx === self.active) self.renderProgress();
      }).then(function () {
        self.usedArts[art] = true;
        // Prüfsumme genau der hochgeladenen Bytes (dasselbe File-Objekt wie im PUT)
        return sha256Hex(file);
      }).then(function (sha) {
        if (s.file !== file) return; // inzwischen ersetzt
        s.origCode = j.code; s.origPath = j.path; s.origSha = sha; s.uploading = false; s.uploadPct = 1;
        self.renderSide();
        self.updateLock();
      });
    }).catch(function (e) {
      if (e && e.grund === 'CODE_ABGELAUFEN' && !retried && s.file === file) {
        // Code älter als 24 h (Tab lange offen): ohne Code neu beginnen, einmal wiederholen
        self.resetCode();
        return self.uploadOriginalNow(idx, true);
      }
      if (s.file === file) { s.uploading = false; s.uploadFailed = true; self.renderSide(); }
      self.updateLock();
      throw e;
    });
  };

  Perso.prototype.startOriginalUpload = function (idx) {
    var self = this, s = this.side[idx], file = s.file;
    s.uploading = true; s.uploadPct = 0;
    this.renderSide();
    this.updateLock();
    this.enqueue(function () {
      if (s.file !== file) return null;
      return self.uploadOriginalNow(idx);
    }).catch(function () {});
  };

  // ------------------------------------------------------------------ Layout + Zeichnen
  Perso.prototype.fontById = function (id) {
    var f = this.cfg.fonts.filter(function (x) { return x.id === id; })[0];
    return f || this.cfg.fonts[0];
  };
  // Entweder-oder (07.10.2026): geltende Art der Seite – BOLD immer 'text', PURE die Wahl im Schalter.
  // '' nur bei Markup ohne Schalter (z. B. alte, gecachte Seite mit neuem JS): dann wie bisher Bild und/oder Text.
  Perso.prototype.artOf = function (idx) {
    if (this.ball === 'BOLD') return 'text';
    if (!this.hasArt) return '';
    return this.side[idx].mode === 'text' ? 'text' : 'bild';
  };
  // Nur die geltende Art zählt (Vorschau, Druck-PNG, Vorschau-PNG, Prüfungen, Properties); die andere bleibt in side gespeichert
  Perso.prototype.usesImage = function (idx) { return this.ball === 'PURE' && this.artOf(idx) !== 'text' && !!this.side[idx].img; };
  Perso.prototype.textLines = function (idx) {
    if (this.artOf(idx) === 'bild') return [];
    return this.side[idx].lines.map(function (l) { return l.trim(); }).filter(function (l) { return l.length; });
  };
  // Größe/Drehung/Position je Art: ändert sich die geltende Art (Schalter oder Ball), Stand tauschen
  Perso.prototype.syncArt = function (idx) {
    var s = this.side[idx], art = this.artOf(idx);
    if (!this.hasArt || s.tfArt === art) return;
    s.tf[s.tfArt] = { zoom: s.zoom, rot: s.rot, x: s.x, y: s.y };
    var n = s.tf[art] || { zoom: 1, rot: 0, x: 0, y: 0 };
    s.zoom = n.zoom; s.rot = n.rot; s.x = n.x; s.y = n.y;
    s.tfArt = art;
    this.layoutCache[idx] = null;
  };
  Perso.prototype.setArt = function (art) {
    var s = this.side[this.active];
    if (this.ball === 'BOLD' || (art !== 'bild' && art !== 'text') || s.mode === art) { this.renderSide(); return; }
    s.mode = art;
    this.syncArt(this.active);
    this.changed(true); // neu zeichnen, Freigabe aufheben
    this.updateLock(); // laufender Upload sperrt nur, wenn das Bild gilt
  };
  // Fix r4: Kern-Zuschnitt auf Wunsch ein/aus (nur die aktive Seite hat den Knopf). Das Bild wird getauscht (Kern bzw. wieder genau der
  // vorige Canvas des ganzen Bildes), Auto-Größe/Vorschau/3D neu (Layout-Cache leer, changed), Freigabe-Häkchen ab (designChanged).
  // imgGen zählt hoch: ein gesetztes dpi-Häkchen gilt für das andere Druckbild nicht mehr. Während „Wird vorbereitet“ gesperrt.
  // Fix r5: erster Klick ohne fertigen Kern-Ausschnitt → kernBerechnen (danach setKern erneut). Umschalten meldet kurz in [data-rp-status]
  // (t.kern_status_an/_aus; war die Freigabe gesetzt oder steht schon t.geaendert, wird t.geaendert angehängt).
  Perso.prototype.setKern = function (idx, an) {
    var s = this.side[idx], t = this.t;
    an = !!an;
    if (this.busy || idx !== this.active || !s.imgGanz || !this.usesImage(idx) || s.kernAn === an) return;
    if (s.img !== s.imgGanz && s.img !== s.imgKern) return; // Bild inzwischen ein anderes (sollte nicht vorkommen)
    if (an && !s.imgKern) { if (s.kernQuelle && !s.kernFehler && !s.kernJob) this.kernBerechnen(idx); return; }
    if (!an && !s.imgKern) return;
    var fg = $(this.root, '[data-rp-check="freigabe"]'), stEl = $(this.root, '[data-rp-status]');
    var erneut = !!(fg && fg.checked) || !!(stEl && t.geaendert && stEl.textContent.indexOf(t.geaendert) >= 0);
    s.kernAn = an;
    s.img = an ? s.imgKern : s.imgGanz;
    s.imgGen = (this.imgGen = (this.imgGen || 0) + 1);
    this.changed(true);
    var msg = an ? t.kern_status_an : t.kern_status_aus;
    if (msg) { this.setStatus(erneut && t.geaendert ? msg + ' ' + t.geaendert : msg); this.statusKern = $(this.root, '[data-rp-status]').textContent; }
  };
  // Fix r5 (T5 r5 Speicher): Kern-Ausschnitt beim ersten Klick – Datei (s.file, für den Original-Upload ohnehin gehalten) neu dekodieren,
  // kernAusschnitt mit s.kernQuelle. Der Klick gilt sofort als Änderung (Freigabe ab, rev++), Kaufbutton bis zum Ende gesperrt (updateLock).
  // Ergebnis gilt nur für dasselbe Bild (s.imgGanz unverändert, kernJob derselbe). Kein Ausschnitt → s.kernFehler: Hinweis ohne Knopf.
  Perso.prototype.kernBerechnen = function (idx) {
    var self = this, s = this.side[idx], q = s.kernQuelle, ganz = s.imgGanz, file = s.file;
    if (!q || !ganz || !file || s.kernJob) return;
    var job = s.kernJob = { ganz: ganz };
    this.designChanged();
    this.updateLock();
    this.renderSide();
    loadImageFromBlob(file).then(function (res) {
      var cv = null;
      try { cv = kernAusschnitt(res.img, q); } catch (e) { cv = null; if (window.console) console.warn('[rlg-perso] Kern-Zuschnitt:', e); }
      URL.revokeObjectURL(res.url);
      return cv;
    }, function () { return null; }).then(function (cv) {
      if (s.kernJob !== job || s.imgGanz !== ganz) { if (cv) cv.width = cv.height = 1; return; } // inzwischen anderes/kein Bild
      s.kernJob = null;
      if (cv) s.imgKern = cv; else s.kernFehler = true;
      self.updateLock();
      var kb = $(self.root, '[data-rp-kern]'), fokus = !!kb && document.activeElement === kb;
      if (cv && idx === self.active && self.usesImage(idx) && !self.busy && s.img === s.imgGanz) self.setKern(idx, true);
      else self.renderSide();
      // Knopf verschwindet (kein Ausschnitt): Fokus nicht verlieren
      if (fokus && kb.hidden) { var fi = $(self.root, '[data-rp-file]'); if (fi && fi.focus) fi.focus(); }
    });
  };
  Perso.prototype.hasContent = function (idx) { return this.usesImage(idx) || this.textLines(idx).length > 0; };
  // Auflösung des gedruckten Bildes einer Seite (09.10.2026): Pixel ohne Rand / gedruckte Breite bei aktueller Größe.
  // dpi abgerundet (Anzeige und Wertung nutzen dieselbe Zahl). null, wenn die Seite kein Bild druckt.
  // 11.10.2026 (kompakt): gedruckte Breite bei Auto-Größe (L.fit); kein maxzoom mehr (es gibt keinen Regler).
  Perso.prototype.resInfo = function (idx) {
    var s = this.side[idx];
    if (!this.usesImage(idx) || !s.img) return null;
    var L = this.layout(idx);
    if (!L || !L.img) return null;
    var mm = L.imgW * L.k * L.fit, w = s.img.width, h = s.img.height;
    if (!(mm > 0) || !(w > 0)) return null;
    var dpi = Math.floor(w / mm * 25.4);
    return { idx: idx, w: w, h: h, mm: mm, dpi: dpi, low: dpi < REC_DPI };
  };
  Perso.prototype.dezimal = function () { return this.t.dezimal || (this.cfg && this.cfg.lang === 'en' ? '.' : ','); };
  Perso.prototype.resMasse = function (r) {
    return fill(this.t.aufl_masse || '[w] × [h]\u00a0px, [mm]\u00a0mm, ≈\u00a0[dpi]\u00a0dpi',
      { w: r.w, h: r.h, mm: round1(r.mm).replace('.', this.dezimal()), dpi: r.dpi });
  };
  // verwendete Bilder unter REC_DPI effektiver Auflösung (09.10.2026, vorher: Bildmaß unter 600 px)
  Perso.prototype.lowResSides = function () {
    var out = [];
    for (var i = 0; i < this.sides; i++) {
      var r = this.resInfo(i);
      if (r && r.low) out.push(r);
    }
    return out;
  };
  // Pflicht-Häkchen, die gerade gelten (sichtbar und aktiv) – das vierte nur bei Bildern unter 600 px
  Perso.prototype.activeChecks = function () {
    return $$(this.root, '[data-rp-check]').filter(function (c) {
      var lab = c.closest('.rlg-perso__check');
      return !c.disabled && !(lab && lab.hidden);
    });
  };
  // 11.10.2026 (kompakt, fail closed): Ohne ein aktives Freigabe-Häkchen (im .rlg-perso__check, nicht hidden, nicht disabled, dargestellt)
  // gibt es kein Absenden – auch wenn das Markup fehlt oder kaputt ist (sonst wäre activeChecks leer und „alle angehakt“ wahr).
  // Dargestellt = hat eine Box und liegt nicht in einem zugeklappten <details> (Fix r1, T5 R4: getClientRects allein liefert dort
  // in Chromium/WebKit 1 Rect) – validate klappt es auf und fokussiert.
  function inZuDetails(c) { return !!(c.closest && c.closest('details:not([open])')); }
  Perso.prototype.freigabeAktiv = function () {
    return $$(this.root, '[data-rp-check="freigabe"]').some(function (c) {
      var lab = c.closest('.rlg-perso__check');
      return !!lab && !lab.hidden && !c.disabled && c.getClientRects().length > 0 && !inZuDetails(c);
    });
  };
  // viertes Häkchen ein-/ausblenden, Maße einsetzen; anderes Bild (Seite, Upload) → wieder abwählen;
  // 09.10.2026: auch abwählen, wenn die effektive Auflösung unter den Stand beim Ankreuzen fällt oder der Stand fehlt (resAck,
  // gesetzt nur im change-Handler – ein vom Browser wiederhergestelltes Häkchen gilt damit nicht)
  Perso.prototype.updateResCheck = function () {
    var wrap = $(this.root, '[data-rp-check-wrap="aufloesung"]');
    if (!wrap) return;
    var box = $(wrap, '[data-rp-check="aufloesung"]'), span = $(wrap, '[data-rp-aufloesung-text]');
    var self = this, t = this.t, low = this.lowResSides();
    var sig = low.map(function (l) { return l.idx + ':' + (self.side[l.idx].imgGen || 0); }).join('|');
    if (sig !== this.resSig) {
      this.resSig = sig;
      box.checked = false;
      this.resAck = null;
      wrap.classList.remove('is-invalid');
    }
    if (box.checked) {
      var ack = this.resAck;
      if (!ack || low.some(function (l) { return !(l.idx in ack) || l.dpi < ack[l.idx]; })) { box.checked = false; this.resAck = null; }
    }
    if (!low.length) { wrap.hidden = true; box.disabled = true; box.checked = false; this.resAck = null; return; }
    var masse = low.map(function (l) {
      return (self.sides > 1 ? (l.idx === 0 ? t.seite_1 : t.seite_2) + ': ' : '') + self.resMasse(l);
    }).join('; ');
    // 09.10.2026: neue Vorlage unter data-vorlage-dpi; data-vorlage (alter Text) bleibt für altes JS im Übergang
    // 11.10.2026 (kompakt): ohne Text-Span (Markup-Fehler) kein TypeError – das Häkchen selbst bleibt Pflicht (fail closed)
    if (span) {
      var vorlage = span.getAttribute('data-vorlage-dpi') || span.getAttribute('data-vorlage') || '';
      var text = /\[w\] × \[h\] px/.test(vorlage) ? vorlage.replace(/\[w\] × \[h\] px/, masse) : fill(vorlage, { w: low[0].w, h: low[0].h });
      if (span.textContent !== text) span.textContent = text;
    }
    wrap.hidden = false;
    box.disabled = !!this.busy; // während der Vorbereitung gesperrt wie die übrigen Häkchen (08.10.2026)
  };

  // Motiv in „Einheiten“ (Schriftgröße 100), k = mm pro Einheit bei Zoom 100 %
  // 11.10.2026 (kompakt): plus Auto-Größe L.fit (statt Zoom) und Versatz L.ox/L.oy (Einheiten); s.zoom/rot/x/y folgen bei JEDEM Aufruf
  Perso.prototype.layout = function (idx) {
    var C = this.layoutCache[idx];
    if (C) { this.tfSync(idx, C); return C; }
    var s = this.side[idx], lines = this.textLines(idx), useImg = this.usesImage(idx);
    if (!lines.length && !useImg) return null;
    var m = makeCanvas(4, 4).getContext('2d');
    var f = this.fontById(s.font);
    var fontCss = f.weight + ' 100px "' + f.family + '", sans-serif';
    m.font = fontCss;
    var ref = m.measureText('HÄgjpÖy');
    var asc = ref.actualBoundingBoxAscent || 80, desc = ref.actualBoundingBoxDescent || 22;
    var pitch = (asc + desc) * 1.08;
    var tw = 0, lineW = [], glyph = [];
    lines.forEach(function (l) {
      var mt = m.measureText(l);
      var w = (mt.actualBoundingBoxLeft != null && mt.actualBoundingBoxRight != null) ? Math.max(mt.width, mt.actualBoundingBoxLeft + mt.actualBoundingBoxRight) : mt.width;
      lineW.push(w); tw = Math.max(tw, w);
      // Fix r4: Glyphen-Box je Zeile (zentriert gesetzt: Ursprung −width/2), für die Box-Prüfung der Prüfdarstellung; null = Maße fehlen
      var ok = [mt.width, mt.actualBoundingBoxLeft, mt.actualBoundingBoxRight, mt.actualBoundingBoxAscent, mt.actualBoundingBoxDescent].every(function (v) { return typeof v === 'number' && isFinite(v); });
      glyph.push(ok ? [-mt.width / 2 - mt.actualBoundingBoxLeft, -mt.actualBoundingBoxAscent, -mt.width / 2 + mt.actualBoundingBoxRight, mt.actualBoundingBoxDescent] : null);
    });
    var th = lines.length ? (lines.length - 1) * pitch + asc + desc : 0;
    var L = { lines: lines, font: fontCss, asc: asc, pitch: pitch, color: s.color, img: null };
    var W, H;
    if (useImg) {
      var iw = s.img.width, ih = s.img.height;
      var boxW, boxH;
      // Bild + Text zusammen gibt es seit 07.10.2026 nicht mehr (textLines leer, solange das Bild gilt) – Zweig bleibt unverändert
      if (lines.length) { boxH = 2.4 * pitch; boxW = Math.max(tw, boxH); }
      else { boxW = 1000; boxH = 1000; }
      var sc = Math.min(boxW / iw, boxH / ih);
      L.img = s.img; L.imgW = iw * sc; L.imgH = ih * sc;
      var gap = lines.length ? 0.35 * pitch : 0;
      W = Math.max(L.imgW, tw); H = L.imgH + gap + th;
      L.imgX = -L.imgW / 2; L.imgY = -H / 2;
      L.textTop = -H / 2 + L.imgH + gap;
    } else {
      W = tw; H = th; L.textTop = -H / 2;
    }
    L.W = W; L.H = H;
    // Fix r4: Layout-Box des Textes in Einheiten (vor Versatz/fit) = Vereinigung der Glyphen-Boxen (Grundlinie je Zeile wie in drawMotif);
    // fehlt ein Maß: L.W × L.H um die Textmitte (Text zentriert, textTop … textTop + th)
    L.tb = null;
    if (lines.length) {
      var gb = null;
      for (var gi = 0; gi < glyph.length; gi++) {
        var g = glyph[gi];
        if (!g) { gb = null; break; }
        var bl = L.textTop + asc + gi * pitch;
        if (!gb) gb = [g[0], bl + g[1], g[2], bl + g[3]];
        else { gb[0] = Math.min(gb[0], g[0]); gb[1] = Math.min(gb[1], bl + g[1]); gb[2] = Math.max(gb[2], g[2]); gb[3] = Math.max(gb[3], bl + g[3]); }
      }
      L.tb = (gb && gb[2] > gb[0] && gb[3] > gb[1]) ? gb : [-tw / 2, L.textTop, tw / 2, L.textTop + th];
    }
    // Zoom 100 %: Motiv-Diagonale passt mit etwas Luft in den sicheren Bereich (in jeder Drehung)
    L.k = (SAFE_MM / 2) * 0.94 / (0.5 * Math.hypot(W, H));
    // 11.10.2026 (kompakt): Rückfall zuerst (fit 1 = alte 100-%-Regel), Cache VOR der Messung setzen (drawMotif → layout ohne Rekursion)
    L.fit = 1; L.ox = 0; L.oy = 0; L.inkWmm = null;
    this.layoutCache[idx] = L;
    var m1 = null;
    // Fix r3: Bild auf seinen eigenen Pixeln messen (ohne Verkleinerung), Text auf der Messleinwand
    try { m1 = (useImg && this.measureInkBild(idx)) || this.measureInk(idx); } catch (e) { m1 = null; if (window.console) console.warn('[rlg-perso] Messung:', e); }
    if (m1) { L.fit = m1.fit; L.ox = m1.ox; L.oy = m1.oy; L.inkWmm = m1.inkWmm; }
    // Fix r4: Text-Box der Prüfdarstellung = gemessene Tinte (engine-unabhängig; WebKit liefert für einzelne Zeichen wie „.“/„-“ zu große
    // actualBoundingBox-Maße), ohne Messung die Glyphen-Box L.tb. Nur bei reinem Text (bei Bild + Text misst measureInkBild nur das Bild).
    L.tinteBox = (!useImg && m1 && m1.inkBox) ? m1.inkBox : null;
    // Fix r3: Bild UND Text an der unbeschnittenen Prüfdarstellung kalibrieren (Bisektion, Ziel FIT_MIN_MM…FIT_R_MM). Ohne Messung ab fit 1
    // (nur verkleinern). Findet die Bisektion keinen sicheren Wert: Rückfall fit 1 mittig; die Endkontrolle beim Absenden bleibt verbindlich.
    var kalOk = false;
    try { kalOk = this.kalibriere(idx, L, m1 ? m1.kappe : 1); } catch (e) { kalOk = false; if (window.console) console.warn('[rlg-perso] Kalibrierung:', e); }
    if (!kalOk) { L.fit = 1; L.ox = 0; L.oy = 0; L.inkWmm = null; L.rPruef = null; }
    this.tfSync(idx, L);
    return L;
  };
  // Fix r3 (T5 r3, T2 r2): Kalibrierung an der UNBESCHNITTENEN Prüfdarstellung (pruefRadiusMm, 60 px/mm wie die Druck-PNG, ohne Kreis-Clip),
  // für Bild und Text. Bisektion zwischen dem größten sicheren fit (r ≤ FIT_R_MM) und dem kleinsten unsicheren (r > FIT_R_MM oder Ausmaß
  // unbekannt); nächster Wert = proportionaler Vorschlag auf FIT_ZIEL_MM, wenn er strikt zwischen den Grenzen liegt, sonst die Mitte.
  // Nach oben höchstens bis kappe (Bild: Quell-Tinte auf FIT_R_MM – die Darstellung kann feine Säume verlieren, die Größe richtet sich nach
  // den Quellpixeln, beide Engines gleich; Text: Messung + 5 %). Fertig bei FIT_MIN_MM ≤ r ≤ FIT_R_MM, an der Kappe oder nach KAL_MAX
  // Darstellungen. true = sicherer Wert gesetzt (L.fit, L.rPruef), false = keiner gefunden (Aufrufer: Rückfall fit 1).
  Perso.prototype.kalibriere = function (idx, L, kappe) {
    var lo = 0, rLo = NaN, hi = Infinity, cand = L.fit, r, next;
    if (!(kappe > 0) || !isFinite(kappe)) kappe = cand;
    L.kalSchritte = 0; L.rPruef = null;
    for (var n = 1; n <= KAL_MAX; n++) {
      if (!(cand > 0) || !isFinite(cand)) break;
      L.fit = cand;
      r = this.pruefRadiusMm(idx);
      L.kalSchritte = n;
      if (!(r > 0)) break; // leer oder Fehler: kein sicherer Wert aus dieser Darstellung
      if (r <= FIT_R_MM) {
        lo = cand; rLo = r;
        if (r >= FIT_MIN_MM || cand >= kappe) break;
      } else hi = cand;
      next = isFinite(r) ? cand * FIT_ZIEL_MM / r : cand / 2;
      if (next > kappe) next = kappe;
      if (lo > 0 && hi < Infinity) {
        if ((hi - lo) / lo < 1e-3) break;
        if (!(next > lo && next < hi)) next = (lo + hi) / 2;
      } else if (lo > 0) {
        if (!(next > lo)) break;
      } else if (!(next < hi)) next = hi / 2;
      cand = next;
    }
    if (lo > 0) { L.fit = lo; L.rPruef = rLo; return true; }
    return false;
  };
  // 11.10.2026 (kompakt): s.zoom/rot/x/y sind nur noch abgeleitet (3D-Signatur, Anzeige) – gezeichnet wird aus L
  Perso.prototype.tfSync = function (idx, L) {
    var s = this.side[idx];
    s.zoom = L.fit; s.rot = 0; s.x = 0; s.y = 0;
  };

  // 11.10.2026 (kompakt): Tinte des Motivs bei fit 1 vermessen (Druck-Kriterium: Bild nach knockOutWhite, Alpha > 0; Text Alpha > 0).
  // Eine Messleinwand je Instanz (willReadFrequently), vor jeder Messung geleert. Liefert fit/ox/oy/Tintenbreite oder null (→ Rückfall fit 1).
  Perso.prototype.measureInk = function (idx) {
    var L = this.layoutCache[idx];
    if (!L) return null;
    var S = MESS_PX, c = this._messCv, x = this._messCtx;
    if (!c) {
      c = makeCanvas(S, S);
      x = c.getContext('2d', { willReadFrequently: true });
      if (!x) return null;
      this._messCv = c; this._messCtx = x;
    }
    x.setTransform(1, 0, 0, 1, 0, 0);
    x.globalAlpha = 1; x.globalCompositeOperation = 'source-over';
    x.clearRect(0, 0, S, S);
    this.drawMotif(x, idx, S / 2, S / 2, MESS_PPM, true);
    if (L.img) knockOutWhite(x, S, S);
    // Fix r4: bei Text nur die Layout-Box (+25 %, ohne Versatz – Messstand) lesen; Tinte am Rand der gelesenen Box = Ausmaß unbekannt (null)
    var gx0 = 0, gy0 = 0, gx1 = S, gy1 = S;
    if (!L.img && L.lines.length) {
      var tr = boxPx({ ox: 0, oy: 0 }, L.tb, S / 2, S / 2, L.k * MESS_PPM, 1.25);
      if (tr) { gx0 = Math.max(0, tr[0]); gy0 = Math.max(0, tr[1]); gx1 = Math.min(S, tr[2]); gy1 = Math.min(S, tr[3]); }
    }
    var gw = gx1 - gx0, gh = gy1 - gy0;
    var d = x.getImageData(gx0, gy0, gw, gh).data;
    var minX = S, maxX = -1, minY = S, maxY = -1, rows = [];
    for (var yy = 0; yy < gh; yy++) {
      var o = yy * gw * 4, l = -1, rr = -1, xx;
      for (xx = 0; xx < gw; xx++) if (d[o + xx * 4 + 3]) { l = xx; break; }
      if (l < 0) continue;
      for (xx = gw - 1; xx >= l; xx--) if (d[o + xx * 4 + 3]) { rr = xx; break; }
      if (yy === 0 || yy === gh - 1 || l === 0 || rr === gw - 1) return null; // Tinte am Rand der Messleinwand bzw. der gelesenen Box: Ausmaß unbekannt
      rows.push(gy0 + yy, gx0 + l, gx0 + rr);
      if (gx0 + l < minX) minX = gx0 + l;
      if (gx0 + rr > maxX) maxX = gx0 + rr;
      if (gy0 + yy < minY) minY = gy0 + yy;
      maxY = gy0 + yy;
    }
    if (maxX < 0) return null;                                         // keine Tinte
    if (minX <= 0 || minY <= 0 || maxX >= S - 1 || maxY >= S - 1) return null; // Tinte am Rand der Messleinwand: Ausmaß unbekannt
    // Mitte der Tinten-Box (Pixelkanten), Radius = weiteste Pixelecke (konservativ)
    var mx = (minX + maxX + 1) / 2, my = (minY + maxY + 1) / 2, r2 = 0;
    for (var i = 0; i < rows.length; i += 3) {
      var y0 = rows[i], dx = Math.max(Math.abs(rows[i + 1] - mx), Math.abs(rows[i + 2] + 1 - mx));
      var dy = Math.max(Math.abs(y0 - my), Math.abs(y0 + 1 - my));
      var q = dx * dx + dy * dy;
      if (q > r2) r2 = q;
    }
    var rMm = Math.sqrt(r2) / MESS_PPM;
    // Fix r3: Vorschlag auf FIT_ZIEL_MM (Mitte des Zielbands), kalibriere prüft an der Druckauflösung; nach oben höchstens + 5 %
    var fit = FIT_ZIEL_MM / rMm, ox = -((mx - S / 2) / MESS_PPM) / L.k, oy = -((my - S / 2) / MESS_PPM) / L.k;
    var inkWmm = (maxX - minX + 1) / MESS_PPM;
    if (!(rMm > 0) || !isFinite(fit) || !(fit > 0) || !isFinite(ox) || !isFinite(oy) || !isFinite(inkWmm)) return null;
    // Fix r4: gemessene Tinten-Box in Einheiten (Messstand fit 1, ohne Versatz) – Grundlage der Text-Box in pruefRadiusMm
    var su = L.k * MESS_PPM, inkBox = [(minX - S / 2) / su, (minY - S / 2) / su, (maxX + 1 - S / 2) / su, (maxY + 1 - S / 2) / su];
    return { fit: fit, kappe: fit * 1.05, ox: ox, oy: oy, inkWmm: inkWmm, rMm: rMm, inkBox: inkBox };
  };

  // Fix r3: Tinte (Kriterium der Druck-PNG nach knockOutWhite: Alpha > 0) an Pixel o eines RGBA-Felds; knock = false: nur Alpha > 0 (Text)
  function tinteAn(d, o, knock) {
    var a = d[o + 3];
    if (!a) return false;
    if (!knock) return true;
    var m = d[o] < d[o + 1] ? d[o] : d[o + 1];
    if (d[o + 2] < m) m = d[o + 2];
    if (m <= KNOCK_LO) return true;
    return m < KNOCK_HI && Math.round(a * (KNOCK_HI - m) / (KNOCK_HI - KNOCK_LO)) > 0;
  }
  // Fix r3 (T5 r3): Bild-Tinte auf den Pixeln des zugeschnittenen Bildes selbst (Arbeitsauflösung, keine Verkleinerung – 1-px-Linien bleiben).
  // Je Zeile linkester/rechtester Tinten-Pixel; einmal je Bild-Canvas berechnet (am Canvas zwischengespeichert).
  function tinteBild(img) {
    if (img._rlgTinte !== undefined) return img._rlgTinte;
    var w = img.width, h = img.height, x = img.getContext && img.getContext('2d', { willReadFrequently: true });
    if (!x || !(w > 0) || !(h > 0)) return null;
    var d = x.getImageData(0, 0, w, h).data, rows = [], minX = w, maxX = -1, minY = -1, maxY = -1, yy, xx, o, l, rr;
    for (yy = 0; yy < h; yy++) {
      o = yy * w * 4; l = -1; rr = -1;
      for (xx = 0; xx < w; xx++) if (tinteAn(d, o + xx * 4, true)) { l = xx; break; }
      if (l < 0) continue;
      for (xx = w - 1; xx >= l; xx--) if (tinteAn(d, o + xx * 4, true)) { rr = xx; break; }
      rows.push(yy, l, rr);
      if (l < minX) minX = l;
      if (rr > maxX) maxX = rr;
      if (minY < 0) minY = yy;
      maxY = yy;
    }
    img._rlgTinte = maxX < 0 ? null : { rows: rows, minX: minX, maxX: maxX, minY: minY, maxY: maxY };
    return img._rlgTinte;
  }
  // Fix r3: fit/ox/oy für ein Bild aus tinteBild – Mitte der Tinten-Box auf die Kreismitte, weiteste Pixelecke auf FIT_ZIEL_MM (Vorschlag),
  // kappe = weiteste Pixelecke auf FIT_R_MM (Obergrenze für kalibriere). null → Messleinwand (measureInk) als Ersatz.
  Perso.prototype.measureInkBild = function (idx) {
    var L = this.layoutCache[idx];
    if (!L || !L.img) return null;
    var T = tinteBild(L.img);
    if (!T) return null;
    var pu = L.imgW / L.img.width; // Einheiten je Bildpixel (waagerecht = senkrecht)
    var mx = (T.minX + T.maxX + 1) / 2, my = (T.minY + T.maxY + 1) / 2, r2 = 0, rows = T.rows;
    for (var i = 0; i < rows.length; i += 3) {
      var y0 = rows[i], dx = Math.max(Math.abs(rows[i + 1] - mx), Math.abs(rows[i + 2] + 1 - mx));
      var dy = Math.max(Math.abs(y0 - my), Math.abs(y0 + 1 - my));
      if (dx * dx + dy * dy > r2) r2 = dx * dx + dy * dy;
    }
    var rMm = Math.sqrt(r2) * pu * L.k, ox = -(L.imgX + mx * pu), oy = -(L.imgY + my * pu);
    var inkWmm = (T.maxX - T.minX + 1) * pu * L.k, fit = FIT_ZIEL_MM / rMm;
    if (!(rMm > 0) || !isFinite(fit) || !(fit > 0) || !isFinite(ox) || !isFinite(oy) || !isFinite(inkWmm)) return null;
    return { fit: fit, kappe: FIT_R_MM / rMm, ox: ox, oy: oy, inkWmm: inkWmm, rMm: rMm };
  };
  // Fix r3 (T5 r3): unbeschnittene Prüfdarstellung – wie renderPrintCanvas (60 px/mm, gleicher Zeichenweg drawMotif, Knockout-Kriterium bei
  // Bild), aber OHNE 20-mm-Kreis-Clip auf PRUEF_PX × PRUEF_PX (26 mm, eine wiederverwendete Leinwand je Instanz). Liefert den weitesten
  // Tinten-Pixel (Pixelecke) in mm ab der Kreismitte; Infinity = Ausmaß nicht sicher bestimmbar (Tinte am Leinwandrand oder Bild-Rechteck
  // ragt über die Leinwand) → gilt als zu groß; 0 = leer; NaN = keine Leinwand.
  Perso.prototype.pruefRadiusMm = function (idx) {
    var L = this.layoutCache[idx];
    if (!L) return 0;
    var S = PRUEF_PX, c = S / 2, x = this._pruefCtx;
    if (!x) {
      var cv = makeCanvas(S, S);
      x = cv.getContext('2d', { willReadFrequently: true });
      if (!x) return NaN;
      this._pruefCv = cv; this._pruefCtx = x;
    }
    var sc = L.k * L.fit * PRUEF_PPM;
    if (L.img) {
      // drawImage malt nur innerhalb seines Zielrechtecks: liegt es ganz auf der Leinwand, sieht die Prüfung jede Tinte des Bildes
      var bx0 = c + (L.ox + L.imgX) * sc, by0 = c + (L.oy + L.imgY) * sc;
      if (!(bx0 >= 1 && by0 >= 1 && bx0 + L.imgW * sc <= S - 1 && by0 + L.imgH * sc <= S - 1)) return Infinity;
    }
    // Fix r4 (T5 r4 Befund 1+2): Text – Box des gesetzten Textes (gemessene Tinte, sonst Glyphen-Box) + 25 % muss auf der Leinwand liegen,
    // sonst Ausmaß unbekannt (Infinity); gelesen wird nur diese Box (bei Bild + Text, alte Seiten ohne Art-Schalter: Box um beides).
    // Reines Bild: ganze Leinwand wie bisher.
    var rx0 = 0, ry0 = 0, rx1 = S, ry1 = S;
    if (L.lines.length) {
      var tr = boxPx(L, L.tinteBox || L.tb, c, c, sc, 1.25);
      if (!tr || tr[0] < 0 || tr[1] < 0 || tr[2] > S || tr[3] > S) return Infinity;
      rx0 = tr[0]; ry0 = tr[1]; rx1 = tr[2]; ry1 = tr[3];
      if (L.img) {
        var ir = boxPx(L, [L.imgX, L.imgY, L.imgX + L.imgW, L.imgY + L.imgH], c, c, sc, 1);
        rx0 = Math.max(0, Math.min(rx0, ir[0])); ry0 = Math.max(0, Math.min(ry0, ir[1])); rx1 = Math.min(S, Math.max(rx1, ir[2])); ry1 = Math.min(S, Math.max(ry1, ir[3]));
      }
    }
    x.setTransform(1, 0, 0, 1, 0, 0);
    x.globalAlpha = 1; x.globalCompositeOperation = 'source-over';
    x.clearRect(0, 0, S, S);
    this.drawMotif(x, idx, c, c, PRUEF_PPM);
    var rw = rx1 - rx0, rh = ry1 - ry0;
    var d = x.getImageData(rx0, ry0, rw, rh).data, knock = this.usesImage(idx), r2 = 0, yy, xx, o, l, rr;
    for (yy = 0; yy < rh; yy++) {
      o = yy * rw * 4; l = -1; rr = -1;
      for (xx = 0; xx < rw; xx++) if (tinteAn(d, o + xx * 4, knock)) { l = xx; break; }
      if (l < 0) continue;
      for (xx = rw - 1; xx >= l; xx--) if (tinteAn(d, o + xx * 4, knock)) { rr = xx; break; }
      // Tinte am Rand der Leinwand bzw. der gelesenen Box: Ausmaß unbekannt
      if (yy === 0 || yy === rh - 1 || l === 0 || rr === rw - 1) return Infinity;
      var ax = rx0 + l, bx = rx0 + rr, ay = ry0 + yy;
      var dx = Math.max(Math.abs(ax - c), Math.abs(bx + 1 - c)), dy = Math.max(Math.abs(ay - c), Math.abs(ay + 1 - c));
      if (dx * dx + dy * dy > r2) r2 = dx * dx + dy * dy;
    }
    return Math.sqrt(r2) / PRUEF_PPM;
  };
  // Fix r4: Box b = [x0, y0, x1, y1] in Einheiten (vor Versatz) → Pixel-Rechteck [x0, y0, x1, y1) einer Leinwand mit Mitte (cx, cy) und
  // Maßstab sc (px je Einheit): um ihre Mitte × faktor vergrößert, mit Versatz L.ox/L.oy, nach außen gerundet + 2 px. null bei ungültigen Werten.
  function boxPx(L, b, cx, cy, sc, faktor) {
    if (!b) return null;
    var mx = (b[0] + b[2]) / 2 + L.ox, my = (b[1] + b[3]) / 2 + L.oy, hw = (b[2] - b[0]) / 2 * faktor, hh = (b[3] - b[1]) / 2 * faktor;
    var out = [Math.floor(cx + (mx - hw) * sc) - 2, Math.floor(cy + (my - hh) * sc) - 2, Math.ceil(cx + (mx + hw) * sc) + 2, Math.ceil(cy + (my + hh) * sc) + 2];
    for (var i = 0; i < 4; i++) if (!isFinite(out[i])) return null;
    return out[2] > out[0] && out[3] > out[1] ? out : null;
  }
  // Fix r5 (T5 r5 Befund 4): Endkontrolle unabhängig von Boxen – nur beim Absenden (nicht je Taste). Ganze Prüfleinwand (PRUEF_PX, 60 px/mm,
  // ohne Kreis-Clip, Kriterium wie pruefRadiusMm) lesen; Tinte am Leinwandrand oder Bild-Rechteck außerhalb = Infinity. Bei Text zusätzlich:
  // jeder Zeilenanker (Grundlinienmitte) innerhalb der groben Leinwand und die grobe Leinwand (GROB_PX bei GROB_PPM = 128 mm) ohne Tinte
  // jenseits GROB_MAX_MM bzw. am Rand – so zählt auch eine Zeile, die ganz außerhalb der Prüfleinwand liegt. Liefert mm (0 = leer).
  var GROB_PPM = 4, GROB_PX = 512, GROB_MAX_MM = 12;
  function randRadiusPx(d, w, h, c, knock) {
    var r2 = 0, yy, xx, o, l, rr;
    for (yy = 0; yy < h; yy++) {
      o = yy * w * 4; l = -1; rr = -1;
      for (xx = 0; xx < w; xx++) if (tinteAn(d, o + xx * 4, knock)) { l = xx; break; }
      if (l < 0) continue;
      for (xx = w - 1; xx >= l; xx--) if (tinteAn(d, o + xx * 4, knock)) { rr = xx; break; }
      if (yy === 0 || yy === h - 1 || l === 0 || rr === w - 1) return Infinity;
      var dx = Math.max(Math.abs(l - c), Math.abs(rr + 1 - c)), dy = Math.max(Math.abs(yy - c), Math.abs(yy + 1 - c));
      if (dx * dx + dy * dy > r2) r2 = dx * dx + dy * dy;
    }
    return Math.sqrt(r2);
  }
  Perso.prototype.endRadiusMm = function (idx) {
    var L = this.layoutCache[idx];
    if (!L) return 0;
    var S = PRUEF_PX, c = S / 2, x = this._pruefCtx, knock = this.usesImage(idx), mmJe = L.k * L.fit;
    if (!x) {
      var cv = makeCanvas(S, S);
      x = cv.getContext('2d', { willReadFrequently: true });
      if (!x) return NaN;
      this._pruefCv = cv; this._pruefCtx = x;
    }
    var sc = mmJe * PRUEF_PPM;
    if (!(sc > 0) || !isFinite(sc)) return NaN;
    if (L.img) {
      var bx0 = c + (L.ox + L.imgX) * sc, by0 = c + (L.oy + L.imgY) * sc;
      if (!(bx0 >= 1 && by0 >= 1 && bx0 + L.imgW * sc <= S - 1 && by0 + L.imgH * sc <= S - 1)) return Infinity;
    }
    var grob = GROB_PX / 2 / GROB_PPM - 1; // mm
    for (var i = 0; i < L.lines.length; i++) {
      var ax = L.ox * mmJe, ay = (L.textTop + L.asc + i * L.pitch + L.oy) * mmJe;
      if (!(Math.abs(ax) < grob && Math.abs(ay) < grob)) return Infinity;
    }
    x.setTransform(1, 0, 0, 1, 0, 0);
    x.globalAlpha = 1; x.globalCompositeOperation = 'source-over';
    x.clearRect(0, 0, S, S);
    this.drawMotif(x, idx, c, c, PRUEF_PPM);
    var r = randRadiusPx(x.getImageData(0, 0, S, S).data, S, S, c, knock) / PRUEF_PPM;
    if (!isFinite(r)) return Infinity;
    if (L.lines.length) {
      var g = makeCanvas(GROB_PX, GROB_PX), gx = g.getContext('2d', { willReadFrequently: true });
      if (!gx) return NaN;
      this.drawMotif(gx, idx, GROB_PX / 2, GROB_PX / 2, GROB_PPM);
      var rg = randRadiusPx(gx.getImageData(0, 0, GROB_PX, GROB_PX).data, GROB_PX, GROB_PX, GROB_PX / 2, knock) / GROB_PPM;
      g.width = g.height = 1;
      if (!(rg <= GROB_MAX_MM)) return Infinity;
    }
    return r;
  };

  // 11.10.2026 (kompakt): Lage/Größe aus dem Layout (Auto-Größe), Drehung 0. mess = true: Messstand fit 1 ohne Versatz (measureInk)
  Perso.prototype.drawMotif = function (ctx, idx, cx, cy, pxPerMm, mess) {
    var L = this.layout(idx);
    if (!L) return;
    var s = this.side[idx];
    ctx.save();
    ctx.translate(cx, cy);
    var sc = L.k * (mess ? 1 : L.fit) * pxPerMm;
    ctx.scale(sc, sc);
    if (!mess) ctx.translate(L.ox, L.oy);
    if (L.img) {
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(L.img, L.imgX, L.imgY, L.imgW, L.imgH);
    }
    if (L.lines.length) {
      ctx.font = L.font;
      // 06.10.2026: Farbe immer aus dem aktuellen Stand (nicht aus dem Layout-Cache) – sonst zeigten Vorschau und
      // Druckdatei nach einem Farbwechsel die alte Farbe, während _Farbe_n schon die neue meldete.
      ctx.fillStyle = s.color || L.color;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'alphabetic';
      for (var i = 0; i < L.lines.length; i++) ctx.fillText(L.lines[i], 0, L.textTop + L.asc + i * L.pitch);
    }
    ctx.restore();
  };

  Perso.prototype.drawBall = function (ctx, key, cx, cy, R) {
    var img = this.ballImg[key], b = this.cfg.ball[key];
    ctx.save();
    ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2); ctx.clip();
    if (img) {
      var sr = b.r * (img.naturalWidth / b.size);
      var scx = b.cx * (img.naturalWidth / b.size), scy = b.cy * (img.naturalHeight / b.size);
      ctx.drawImage(img, scx - sr, scy - sr, sr * 2, sr * 2, cx - R, cy - R, R * 2, R * 2);
    } else {
      // Ersatz ohne Bild: Kugel mit Verlauf
      var g = ctx.createRadialGradient(cx - R * 0.3, cy - R * 0.35, R * 0.1, cx, cy, R);
      g.addColorStop(0, '#ffffff'); g.addColorStop(0.35, b.fallback); g.addColorStop(1, '#9a9a9a');
      ctx.fillStyle = b.fallback; ctx.fillRect(cx - R, cy - R, 2 * R, 2 * R);
      ctx.globalCompositeOperation = 'multiply'; ctx.fillStyle = g; ctx.fillRect(cx - R, cy - R, 2 * R, 2 * R);
    }
    ctx.restore();
  };

  // Ball + Motiv (multiply) – für Live-Vorschau und Vorschau-PNG
  Perso.prototype.drawBallWithMotif = function (ctx, idx, cx, cy, ballR, opts) {
    opts = opts || {};
    var pxPerMm = ballR / (BALL_MM / 2);
    var pr = (PRINT_MM / 2) * pxPerMm;
    this.drawBall(ctx, this.ball, cx, cy, ballR);
    // Motiv innerhalb des Druckkreises: multiply (Weiß verschwindet, Farben kippen auf Gelb)
    ctx.save();
    ctx.beginPath(); ctx.arc(cx, cy, pr, 0, Math.PI * 2); ctx.clip();
    ctx.globalCompositeOperation = 'multiply';
    this.drawMotif(ctx, idx, cx, cy, pxPerMm);
    ctx.restore();
    if (opts.ghost) {
      // alles außerhalb des Druckkreises blass (wird nicht gedruckt)
      ctx.save();
      ctx.beginPath();
      ctx.rect(cx - ballR * 3, cy - ballR * 3, ballR * 6, ballR * 6);
      ctx.arc(cx, cy, pr, 0, Math.PI * 2, true);
      ctx.clip('evenodd');
      ctx.globalAlpha = 0.28;
      this.drawMotif(ctx, idx, cx, cy, pxPerMm);
      ctx.restore();
    }
    if (opts.guides) {
      // Fix r3 (T6 r3): nur der rote 20-mm-Kreis; die gestrichelte 18-mm-Linie entfällt (bei Auto-Größe ohne Funktion, Motiv berührt sie)
      ctx.save();
      ctx.lineWidth = Math.max(1, pxPerMm * 0.12);
      ctx.strokeStyle = 'rgba(200, 16, 46, 0.85)';
      ctx.beginPath(); ctx.arc(cx, cy, pr, 0, Math.PI * 2); ctx.stroke();
      ctx.restore();
    }
  };

  Perso.prototype.previewGeometry = function () {
    var w = this.canvas.clientWidth || 300;
    var c = w / 2, ballR;
    if (this.view === 'nah') ballR = (w * 0.44) * (BALL_MM / PRINT_MM);
    else ballR = w * 0.47;
    return { w: w, c: c, ballR: ballR, pxPerMm: ballR / (BALL_MM / 2) };
  };

  Perso.prototype.drawPreview = function () {
    var cv = this.canvas, g = this.previewGeometry();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    while (g.w * dpr * g.w * dpr > MAX_CANVAS_AREA && dpr > 1) dpr -= 0.25;
    var px = Math.round(g.w * dpr);
    if (cv.width !== px || cv.height !== px) { cv.width = px; cv.height = px; }
    var ctx = this.ctx;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, px, px);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    this.drawBallWithMotif(ctx, this.active, g.c, g.c, g.ballR, { ghost: true, guides: true });
    $(this.root, '[data-rp-empty]').hidden = this.hasContent(this.active);
    this.d3Ruf('aenderung');
  };

  // 11.10.2026 (kompakt): Randprüfung checkBounds/warn_rand/warn_nah entfällt (Auto-Größe legt jedes Motiv an FIT_R_MM;
  // die verbindliche Prüfung läuft jetzt an der fertigen Druck-PNG: druckRadiusMm in prepareAndSubmit)

  // Fix r2: Breite der Tinte (Alpha > 0, linkester bis rechtester Pixel) einer Druck-PNG in mm; 0 = leer
  function druckBreiteMm(canvas) {
    var n = canvas.width, h = canvas.height, d = canvas.getContext('2d').getImageData(0, 0, n, h).data, l0 = n, r0 = -1;
    for (var yy = 0; yy < h; yy++) {
      var o = yy * n * 4, xx;
      for (xx = 0; xx < l0; xx++) if (d[o + xx * 4 + 3]) { l0 = xx; break; }
      for (xx = n - 1; xx > r0; xx--) if (d[o + xx * 4 + 3]) { r0 = xx; break; }
    }
    return r0 < l0 ? 0 : (r0 - l0 + 1) * PRINT_MM / n;
  }
  // Weitester Pixel mit Alpha > 0 einer Druck-PNG (Canvas PRINT_PX × PRINT_PX, Mitte = Kreismitte) in mm, Pixelecke (konservativ); 0 = leer
  Perso.prototype.druckRadiusMm = function (canvas) {
    var n = canvas.width, x = canvas.getContext('2d'), d = x.getImageData(0, 0, n, canvas.height).data;
    var h = canvas.height, c = n / 2, cyy = h / 2, r2 = 0;
    for (var yy = 0; yy < h; yy++) {
      var o = yy * n * 4, l = -1, rr = -1, xx;
      for (xx = 0; xx < n; xx++) if (d[o + xx * 4 + 3]) { l = xx; break; }
      if (l < 0) continue;
      for (xx = n - 1; xx >= l; xx--) if (d[o + xx * 4 + 3]) { rr = xx; break; }
      var dx = Math.max(Math.abs(l - c), Math.abs(rr + 1 - c)), dy = Math.max(Math.abs(yy - cyy), Math.abs(yy + 1 - cyy));
      if (dx * dx + dy * dy > r2) r2 = dx * dx + dy * dy;
    }
    return Math.sqrt(r2) * PRINT_MM / n;
  };

  // ------------------------------------------------------------------ Darstellung
  Perso.prototype.renderAll = function () {
    var r = this.root;
    this.syncArt(0); this.syncArt(1); // Ballwechsel kann die geltende Art ändern (BOLD → Text)
    // 11.10.2026 (kompakt): ganze Tab-Leiste nur bei beidseitig (einseitig: keine Funktion)
    var tabs = $(r, '[data-rp-tabs]');
    if (tabs) tabs.hidden = this.sides < 2;
    var tab2 = $(r, '[data-rp-tab="1"]');
    tab2.hidden = this.sides < 2;
    $(r, '[data-rp-side2-note]').hidden = this.sides < 2;
    var bold = this.ball === 'BOLD';
    $(r, '[data-rp-upload-area]').hidden = bold;
    $(r, '[data-rp-bold-note]').hidden = !bold;
    $(r, '[data-rp-color-note]').hidden = !bold;
    $$(r, '[data-rp-color]').forEach(function (lab) {
      lab.hidden = bold && lab.getAttribute('data-bold') !== '1';
    });
    this.renderTabs();
    this.renderSide();
    this.drawPreview();
    if (this.form) this.updateLock();
  };

  Perso.prototype.renderTabs = function () {
    var self = this;
    $$(this.root, '[data-rp-tab]').forEach(function (b) {
      var i = +b.getAttribute('data-rp-tab'), sel = i === self.active;
      b.setAttribute('aria-selected', sel ? 'true' : 'false');
      b.tabIndex = sel ? 0 : -1;
    });
    $$(this.root, '[data-rp-tabstate]').forEach(function (d) {
      d.classList.toggle('is-done', self.hasContent(+d.getAttribute('data-rp-tabstate')));
    });
    $(this.root, '[data-rp-panel]').setAttribute('aria-labelledby', $(this.root, '[data-rp-tab="' + this.active + '"]').id);
  };

  Perso.prototype.renderSide = function () {
    var r = this.root, s = this.side[this.active], t = this.t;
    $$(r, '[data-rp-line]').forEach(function (inp) {
      var i = +inp.getAttribute('data-rp-line');
      if (inp.value !== s.lines[i]) inp.value = s.lines[i];
      var cnt = $(r, '[data-rp-count="' + i + '"]');
      cnt.textContent = s.lines[i].length + '/' + MAX_LINE;
      cnt.classList.toggle('is-full', s.lines[i].length >= MAX_LINE);
    });
    $$(r, '[data-rp-fonts] input').forEach(function (inp) { inp.checked = inp.value === s.font; });
    $$(r, '[data-rp-colors] input').forEach(function (inp) { inp.checked = inp.value === s.color; });
    // 11.10.2026 (kompakt): keine Regler-Anzeige mehr (Auto-Größe)

    var lbl = $(r, '[data-rp-file-label]');
    lbl.textContent = s.img ? lbl.getAttribute('data-label-replace') : lbl.getAttribute('data-label-new');
    $(r, '[data-rp-remove]').hidden = !s.img;
    var fn = $(r, '[data-rp-filename]');
    fn.hidden = !s.img;
    fn.textContent = s.img ? s.fileName + ' (' + s.origW + ' × ' + s.origH + ' px)' : '';

    // Fix r5: Soll-Liste der Meldungen ({ c: Klasse, a: Daten-Attribut, t: Text }); das DOM nur ändern, wenn sie sich unterscheidet
    var ul = $(r, '[data-rp-msgs]'), soll = [];
    var res = this.resInfo(this.active); // 09.10.2026: Auflösungshinweis live je Größe (statt einmalig beim Hochladen)
    if (res && res.low) {
      // 11.10.2026 (kompakt): kein Zoom-Rat mehr (Auto-Größe) → immer hint_aufl_datei (nie hint_aufl mit [maxzoom])
      soll.push({ c: 'is-warn', a: 'data-rp-hint-aufloesung',
        t: fill(t.hint_aufl_datei, { w: res.w, h: res.h, dpi: res.dpi, mm: round1(res.mm).replace('.', this.dezimal()) }) });
    }
    // Fix r1 (T6): aufeinanderfolgende OK-Meldungen in EINER Zeile („Transparenter Hintergrund erkannt. Hochgeladen.“) – spart eine Box
    function okDazu(text) {
      var last = soll[soll.length - 1];
      if (last && last.c === 'is-ok' && !last.a) last.t += ' ' + text;
      else soll.push({ c: 'is-ok', t: text });
    }
    // Fix r4: Punkte-Hinweis als letzte Meldung, direkt darunter (außerhalb der Live-Region) der Knopf [data-rp-kern]
    var punkteMsg = null;
    s.msgs.forEach(function (m) {
      if (m.punkte) { punkteMsg = m; return; }
      if (m.type === 'ok') okDazu(m.text); else soll.push({ c: 'is-' + m.type, t: m.text });
    });
    if (s.img && s.uploading) soll.push({ c: 'is-info', a: 'data-rp-upmsg', t: fill(t.upload_laeuft, { p: Math.round(s.uploadPct * 100) }) });
    else if (s.img && s.origPath && s.origCode === this.code) okDazu(t.upload_fertig);
    else if (s.img && s.uploadFailed) soll.push({ c: 'is-warn', t: t.upload_fehler });
    var kb = $(r, '[data-rp-kern]');
    // Fix r5: Knopf nur, wenn der Kern-Ausschnitt da ist oder noch berechnet werden kann; im Kern-Zustand Info-Text t.kern_info,
    // ohne verfügbaren Ausschnitt der Hinweis ohne Knopf-Verweis (t.hint_punkte_ohne; altes Snippet ohne die Texte: t.hint_punkte)
    var kernOk = !!punkteMsg && !!kb && !!s.imgGanz && this.usesImage(this.active) && !!t.kern_an && !!t.kern_aus &&
      (!!s.imgKern || (!!s.kernQuelle && !s.kernFehler));
    if (punkteMsg) {
      if (s.kernAn && s.imgKern && s.img === s.imgKern && t.kern_info) soll.push({ c: 'is-info', a: 'data-rp-hint-punkte', t: t.kern_info });
      else soll.push({ c: 'is-' + punkteMsg.type, a: 'data-rp-hint-punkte', t: kernOk || !t.hint_punkte_ohne ? t.hint_punkte : t.hint_punkte_ohne });
    }
    var ist = ul.children, gleich = ist.length === soll.length;
    for (var mi = 0; gleich && mi < soll.length; mi++) {
      var li = ist[mi], m = soll[mi];
      gleich = li.className === m.c && li.textContent === m.t && li.attributes.length === (m.a ? 2 : 1) && (!m.a || li.hasAttribute(m.a));
    }
    if (!gleich) {
      ul.textContent = '';
      soll.forEach(function (m) { var at = { 'class': m.c }; if (m.a) at[m.a] = ''; ul.appendChild(el('li', at, m.t)); });
    }
    if (kb) {
      kb.hidden = !kernOk;
      var kTxt = s.kernAn ? t.kern_aus : t.kern_an;
      if (kernOk && kb.textContent !== kTxt) kb.textContent = kTxt;
      if (s.kernJob) kb.setAttribute('aria-busy', 'true'); else kb.removeAttribute('aria-busy'); // Fix r5: Berechnung läuft
    }
    this.renderProgress();
    this.renderTabs();
    this.renderArt();
    this.updateResCheck();
  };

  // Schalter und Felder der aktiven Seite: nur die geltende Art sichtbar und bedienbar (hidden + disabled), die andere bleibt gefüllt
  Perso.prototype.renderArt = function () {
    if (!this.hasArt) return;
    var r = this.root, s = this.side[this.active], art = this.artOf(this.active), bold = this.ball === 'BOLD';
    var lock = !!this.busy; // „Wird vorbereitet“: Schalter, Datei und Textfelder gesperrt (08.10.2026)
    $$(r, '[data-rp-art-opt]').forEach(function (inp) {
      inp.checked = inp.value === art;
      inp.disabled = lock || (bold && inp.value === 'bild');
    });
    var up = $(r, '[data-rp-upload-group]');
    up.hidden = art !== 'bild';
    up.disabled = lock || art !== 'bild';
    $$(r, '[data-rp-text-group]').forEach(function (g) { g.hidden = art !== 'text'; g.disabled = lock || art !== 'text'; });
    var hasText = s.lines.some(function (l) { return l.trim().length > 0; });
    $(r, '[data-rp-art-keep="text"]').hidden = !(art === 'bild' && hasText);
    $(r, '[data-rp-art-keep="bild"]').hidden = !(art === 'text' && !bold && !!s.img);
  };

  Perso.prototype.renderProgress = function () {
    var s = this.side[this.active];
    var bar = $(this.root, '[data-rp-progress]');
    bar.hidden = !(s.img && s.uploading);
    $(this.root, '[data-rp-progress-bar]').style.width = Math.round((s.uploadPct || 0) * 100) + '%';
    var m = $(this.root, '[data-rp-upmsg]');
    if (m) m.textContent = fill(this.t.upload_laeuft, { p: Math.round((s.uploadPct || 0) * 100) });
  };

  Perso.prototype.setActive = function (i) {
    if (i >= this.sides) i = 0;
    this.active = i;
    this.renderSide();
    this.drawPreview();
    this.d3Ruf('seite', i);
  };

  // Schrift geladen o. Ä.: alle Layouts neu. 11.10.2026 (kompakt): Mit Auto-Größe ändern sich dabei Größe/Lage → hat sich bei einer
  // schon vermessenen Seite fit/ox/oy/k geändert, gilt das als Motivänderung (Freigabe-Häkchen ab, rev++)
  Perso.prototype.invalidate = function () {
    var self = this, sig = function (L) { return L ? [L.k, L.fit, L.ox, L.oy].map(function (v) { return Math.round(v * 1e6); }).join(',') : ''; };
    var alt = this.layoutCache.map(sig);
    this.layoutCache = [null, null];
    var anders = alt.some(function (a, i) { return a !== '' && sig(self.layout(i)) !== a; });
    this.drawPreview();
    if (anders) { this.renderSide(); this.designChanged(); }
  };

  // layoutChanged: Text/Schrift/Bild geändert (Layout neu berechnen). 11.10.2026 (kompakt): kein Ziehen mehr – live ohne Regler-Anzeige
  Perso.prototype.changed = function (layoutChanged, live) {
    if (layoutChanged) this.layoutCache[this.active] = null;
    if (!live) this.renderSide();
    else this.updateResCheck(); // 09.10.2026
    this.drawPreview();
    this.designChanged();
  };

  // Jede Änderung am Motiv hebt die Druckfreigabe auf
  Perso.prototype.designChanged = function () {
    this.rev++; // 08.10.2026: Absenden bricht ab, wenn sich der Stand während der Vorbereitung geändert hat (auch A→B→A)
    var f = $(this.root, '[data-rp-check="freigabe"]');
    if (f && f.checked) {
      f.checked = false;
      this.setStatus(this.t.geaendert);
    } else if (this.statusKern) {
      // Fix r5: Kern-Meldung (setKern) ist nach einer weiteren Änderung veraltet – ggf. bleibt nur t.geaendert stehen
      var st = $(this.root, '[data-rp-status]');
      if (st && st.textContent === this.statusKern) this.setStatus(this.statusKern.indexOf(this.t.geaendert) >= 0 ? this.t.geaendert : '');
    }
    this.statusKern = null;
    this.hideError();
  };

  // kurzer Hinweis unter den Textzeilen, wenn Zeichen entfernt wurden
  Perso.prototype.showTextHint = function () {
    var h = $(this.root, '[data-rp-text-hint]');
    if (!h) return;
    h.textContent = this.t.hint_zeichen;
    h.hidden = false;
    clearTimeout(this.textHintTimer);
    this.textHintTimer = setTimeout(function () { h.hidden = true; h.textContent = ''; }, 7000);
  };

  // Weihnachts-Bestellschluss: Liquid blendet den Hinweis serverseitig aus; gecachte Seiten prüft das JS (Zeitpunkt aus data-rp-bis)
  // 11.10.2026 (kompakt): im ganzen Dokument – die Hinweise stehen jetzt unter dem Kaufbutton (Teil 'hinweise', außerhalb von this.root)
  Perso.prototype.checkDeadlines = function () {
    $$(document, '[data-rp-bis]').forEach(function (n) {
      var bis = Date.parse(n.getAttribute('data-rp-bis'));
      if (!isNaN(bis) && Date.now() > bis && n.parentNode) n.parentNode.removeChild(n);
    });
  };

  // Motiv-Code verwerfen (z. B. 409 CODE_ABGELAUFEN): nächste Signierung holt einen neuen Code, Originale werden neu hochgeladen
  Perso.prototype.resetCode = function () {
    this.code = null;
    this.usedArts = {};
    this.side.forEach(function (s) { s.origCode = null; s.origPath = ''; s.origSha = ''; });
  };

  // Fix r1: Meldung bei gescheiterter Endkontrolle; altes Snippet (ohne t.err_vorbereitung) bekommt einen festen Text statt
  // t.upload_fehler („… versuchen es beim Bestellen noch einmal“ passte nicht)
  Perso.prototype.errVorbereitung = function () {
    return this.t.err_vorbereitung || (this.cfg && this.cfg.lang === 'en'
      ? 'Your design could not be prepared for printing. Please try again – for an image, ideally use a PNG with a transparent background.'
      : 'Dein Motiv konnte nicht für den Druck vorbereitet werden. Bitte versuch es noch einmal – bei einem Bild am besten als PNG mit transparentem Hintergrund.');
  };
  Perso.prototype.setStatus = function (txt) { $(this.root, '[data-rp-status]').textContent = txt || ''; };
  Perso.prototype.showError = function (txt) {
    var e = $(this.root, '[data-rp-error]');
    e.textContent = txt; e.hidden = false;
  };
  Perso.prototype.hideError = function () {
    var e = $(this.root, '[data-rp-error]');
    if (!e.hidden) { e.hidden = true; e.textContent = ''; }
  };

  // ------------------------------------------------------------------ Absenden
  Perso.prototype.validate = function () {
    var t = this.t, errs = [], firstFocus = null, r = this.root;
    if (this.cfg.paused) return { errs: [t.hinweis_pausiert], focus: null };
    if (!this.variantConsistent()) return { errs: [t.err_variante], focus: null };
    for (var i = 0; i < this.sides; i++) {
      var label = i === 0 ? t.seite_1 : t.seite_2;
      if (!this.hasContent(i)) {
        var leer = this.ball === 'BOLD' ? t.err_bold_text : t.err_seite_leer;
        // 08.10.2026 (Review): „Bild oder Logo“ gewählt, kein Bild, aber Text gespeichert → Meldung nennt den Schalter
        if (this.artOf(i) === 'bild' && t.err_seite_leer_text && this.side[i].lines.some(function (l) { return l.trim().length > 0; })) leer = t.err_seite_leer_text;
        errs.push(fill(leer, { seite: label }));
        if (firstFocus == null) firstFocus = { side: i, el: this.artOf(i) === 'bild' ? '[data-rp-file]' : '[data-rp-line="0"]' };
      }
      if (this.textLines(i).length && this.fontPending(this.fontById(this.side[i].font))) {
        // Vorschau zeigte evtl. eine Ersatzschrift: nach dem Laden neu zeichnen und neu freigeben lassen (Fix r5: schriftGeladen);
        // nach Fristablauf ('error') neuer Ladeversuch – Absenden bleibt gesperrt, bis die Schrift wirklich geladen ist
        this.loadFonts(true);
        errs.push(t.err_schrift);
        if (firstFocus == null) firstFocus = { side: i, el: null };
      }
      if (this.usesImage(i) && this.side[i].uploading) {
        errs.push(t.err_upload_offen);
        if (firstFocus == null) firstFocus = { side: i, el: null };
      }
      if (this.usesImage(i) && this.side[i].kernJob) { // Fix r5: Kern-Ausschnitt wird gerade berechnet (Kaufbutton ohnehin gesperrt)
        errs.push(t.vorbereiten);
        if (firstFocus == null) firstFocus = { side: i, el: null };
      }
    }
    var missing = false, fehltDpi = false, fehltAndere = false;
    this.updateResCheck();
    // Fix r1: fehlt NUR das dpi-Häkchen, eigene Meldung (t.err_haekchen_dpi; ohne den Text – altes Snippet – wie bisher t.err_haekchen)
    function fehlt(c) { missing = true; if (c.getAttribute('data-rp-check') === 'aufloesung') fehltDpi = true; else fehltAndere = true; }
    $$(r, '[data-rp-check]').forEach(function (c) {
      var lab = c.closest('.rlg-perso__check');
      if (!lab) { if (!c.disabled && !c.checked) { fehlt(c); if (firstFocus == null) firstFocus = { side: null, node: c }; } return; } // 11.10.2026: kein TypeError
      if (c.disabled || lab.hidden) { lab.classList.remove('is-invalid'); return; } // viertes Häkchen ohne kleines Bild: gilt nicht
      // Fix r1: gesetzt, aber in einem zugeklappten <details> = nicht gesehen → wie nicht gesetzt (onSubmit klappt auf und fokussiert)
      if (!c.checked || inZuDetails(c)) {
        fehlt(c); lab.classList.add('is-invalid');
        if (firstFocus == null) firstFocus = { side: null, node: c };
      } else lab.classList.remove('is-invalid');
    });
    // 11.10.2026 (kompakt, fail closed): ohne aktives Freigabe-Häkchen nie absenden (fehlendes/verstecktes/zugeklapptes Markup)
    if (!this.freigabeAktiv()) {
      missing = true; fehltAndere = true;
      var fg = $(r, '[data-rp-check="freigabe"]');
      if (fg && firstFocus == null) firstFocus = { side: null, node: fg };
    }
    if (missing) errs.push(fehltDpi && !fehltAndere && t.err_haekchen_dpi ? t.err_haekchen_dpi : t.err_haekchen);
    return { errs: errs, focus: firstFocus };
  };

  Perso.prototype.onSubmit = function (e) {
    var form = e.target;
    if (!form || !form.getAttribute || form.getAttribute('id') !== this.formId) return;
    if (this.allowSubmit) { // eigener requestSubmit → Theme übernimmt
      this.allowSubmit = false; this.lastSubmitted = true;
      this.inFlightUntil = Date.now() + 15000; // bis ajaxProduct:added/error (oder max. 15 s) kein zweites Absenden
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (this.busy) return;
    if (this.inFlightUntil && Date.now() < this.inFlightUntil) return;
    if (this.cfg.paused) return; // Hinweis steht schon oben, Button ist gesperrt
    var submitter = e.submitter || null;
    var v = this.validate();
    if (v.errs.length) {
      this.showError(v.errs.join(' '));
      if (v.focus) {
        if (v.focus.side != null && v.focus.side !== this.active) this.setActive(v.focus.side);
        var node = v.focus.node || (v.focus.el && $(this.root, v.focus.el));
        if (node && node.focus) {
          // 11.10.2026 (kompakt): liegt das Ziel in einem zugeklappten <details>, erst aufklappen, dann sichtbar machen und fokussieren
          var det = node.closest && node.closest('details');
          if (det && !det.open) det.open = true;
          try { if (node.scrollIntoView) node.scrollIntoView({ block: 'center' }); } catch (x) {}
          node.focus();
        }
      }
      return;
    }
    this.prepareAndSubmit(form, submitter);
  };

  Perso.prototype.setBusy = function (on) {
    this.busy = on;
    this.updateLock();
    // 08.10.2026 (Review): während der Vorbereitung Häkchen, Schalter, Textfelder und Datei sperren (das vierte Häkchen über updateResCheck)
    $$(this.root, '[data-rp-check]').forEach(function (c) { if (c.getAttribute('data-rp-check') !== 'aufloesung') c.disabled = on; });
    this.updateResCheck();
    this.renderArt();
  };

  // Kaufbutton sperren, solange vorbereitet oder ein Original hochgeladen wird (idempotent)
  Perso.prototype.updateLock = function () {
    var self = this;
    var lock = this.busy || this.side.some(function (s, i) { return i < self.sides && (s.uploading || s.kernJob) && self.usesImage(i); }); // Fix r5: + kernJob
    this._locked = lock;
    this.buyButtons().forEach(function (b) {
      var mine = b.classList.contains('rlg-perso-busy');
      if (lock) {
        if (!mine) {
          b._rpWasDisabled = b.disabled;
          b.classList.add('rlg-perso-busy');
          b.setAttribute('aria-busy', 'true');
        }
        b.disabled = true;
      } else if (mine) {
        b.disabled = !!b._rpWasDisabled || !!self.cfg.paused || b.hasAttribute('loading') || b.hasAttribute('unavailable');
        b.removeAttribute('aria-busy');
        b.classList.remove('rlg-perso-busy');
      }
    });
  };

  // Druck-PNG einer Seite als Canvas (08.10.2026 aus renderPrintBlob ausgelagert, Abfolge unverändert). Ohne fach: neues Canvas wie
  // bisher (Druckweg). Mit fach (3D-Vorschau, ein Objekt je Seite): Canvas derselben Kontext-Art wiederverwenden, vorher ganz geleert.
  Perso.prototype.renderPrintCanvas = function (idx, fach) {
    var useImg = this.usesImage(idx), c, x;
    if (fach) {
      var k = useImg ? 'mitBild' : 'ohneBild';
      if (!fach[k]) { fach[k] = makeCanvas(PRINT_PX, PRINT_PX); fach[k + 'Ctx'] = fach[k].getContext('2d', useImg ? { willReadFrequently: true } : undefined); }
      c = fach[k]; x = fach[k + 'Ctx'];
      x.setTransform(1, 0, 0, 1, 0, 0);
      x.clearRect(0, 0, PRINT_PX, PRINT_PX);
    } else {
      c = makeCanvas(PRINT_PX, PRINT_PX);
      x = c.getContext('2d', useImg ? { willReadFrequently: true } : undefined);
    }
    x.save();
    x.beginPath(); x.arc(PRINT_PX / 2, PRINT_PX / 2, PRINT_PX / 2, 0, Math.PI * 2); x.clip();
    this.drawMotif(x, idx, PRINT_PX / 2, PRINT_PX / 2, PRINT_PX / PRINT_MM);
    x.restore();
    // nur mit Bild (PURE): Weiß → transparent. Reiner Text (BOLD/PURE) bleibt bytegleich wie bisher.
    if (useImg) knockOutWhite(x, PRINT_PX, PRINT_PX);
    return c;
  };
  // Der Blob entsteht erst nach dem Ausstanzen → _SHA_Druck_n läuft über die endgültigen, hochgeladenen Bytes.
  Perso.prototype.renderPrintBlob = function (idx) { return canvasToBlob(this.renderPrintCanvas(idx), 'image/png'); };

  Perso.prototype.renderPreviewBlob = function () {
    var one = 800, n = this.sides;
    var c = makeCanvas(one * n, one), x = c.getContext('2d');
    x.fillStyle = '#ffffff'; x.fillRect(0, 0, c.width, c.height);
    for (var i = 0; i < n; i++) {
      this.drawBallWithMotif(x, i, one * i + one / 2, one / 2 + 20, one * 0.44, { ghost: false, guides: false });
      if (n > 1) {
        x.fillStyle = '#171717';
        x.font = '600 28px system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
        x.textAlign = 'left'; x.textBaseline = 'top';
        x.fillText(i === 0 ? this.t.seite_1 : this.t.seite_2, one * i + 24, 20);
      }
    }
    return canvasToBlob(c, 'image/png');
  };

  Perso.prototype.sideSummary = function (idx) {
    var t = this.t, parts = [], s = this.side[idx];
    if (this.usesImage(idx)) parts.push(t.prop_bild + ' (' + String(s.fileName).slice(0, 60) + ')');
    var lines = this.textLines(idx);
    if (lines.length) parts.push(t.prop_text + ': ' + lines.join(' / '));
    return safeVisible(parts.join(' + '));
  };

  Perso.prototype.setProps = function (props) {
    var box = $(this.root, '[data-rp-props]'), fid = this.formId;
    box.textContent = '';
    Object.keys(props).forEach(function (k) {
      var inp = el('input', { type: 'hidden', name: 'properties[' + k + ']', form: fid });
      inp.value = props[k];
      box.appendChild(inp);
    });
  };

  Perso.prototype.prepareAndSubmit = function (form, submitter) {
    var self = this, t = this.t;
    this.hideError();
    this.setBusy(true);
    this.setStatus(t.vorbereiten);
    $(this.root, '[data-rp-props]').textContent = '';
    var result = {}, sha = {}, breite = {};
    var snap = { ball: this.ball, sides: this.sides, variant: (this.form.querySelector('[name="id"]') || {}).value, arts: this.artOf(0) + ',' + this.artOf(1), rev: this.rev };
    // alle geltenden Pflicht-Häkchen (3, bei Bildern unter 600 px 4) müssen auch am Ende der Vorbereitung noch gesetzt sein
    // 11.10.2026 (kompakt, fail closed): leere Liste ist NICHT „alle angehakt“ – ein aktives Freigabe-Häkchen muss da sein
    // Fix r1: ein gesetztes Häkchen in einem zugeklappten <details> zählt nicht (fail closed, wie validate)
    function allChecked() { self.updateResCheck(); return self.freigabeAktiv() && self.activeChecks().every(function (c) { return c.checked && !inZuDetails(c); }); }
    function runChain() {
      result = {}; sha = {}; breite = {};
      var p = Promise.resolve();
      // 1. Originale (falls noch nicht unter dem aktuellen Code)
      for (var i = 0; i < self.sides; i++) {
        (function (idx) {
          if (self.usesImage(idx)) p = p.then(function () { return self.uploadOriginalNow(idx); });
        })(i);
      }
      // 2. Druck-PNGs – 11.10.2026 (kompakt): Endkontrolle an der fertigen Druck-PNG vor dem Hochladen (weitester Pixel ≤ CHECK_R_MM, fail closed)
      for (var j = 0; j < self.sides; j++) {
        (function (idx) {
          p = p.then(function () {
            // Fix r1 (T2 r4): wirft das Rendern/Messen selbst, gilt das als gescheiterte Endkontrolle (eigene Meldung, keine technische)
            // Fix r3: zusätzlich die unbeschnittene Prüfdarstellung (Tinte jenseits des Kreises, die die Druck-PNG wegschneiden würde) ≤ CHECK_R_MM;
            // _Groesse_mm_n = Tintenbreite genau dieser Druck-PNG
            // Fix r5: Text nie mit Ersatzschrift drucken – Schrift muss hier (nicht nur in validate) sicher geladen sein
            if (self.textLines(idx).length && self.fontPending(self.fontById(self.side[idx].font))) {
              self.loadFonts(true);
              var se = new Error(t.err_schrift); se.vorbereitung = true; throw se;
            }
            // Fix r5: zusätzlich endRadiusMm – ganze Prüfleinwand (+ bei Text grobe Leinwand/Zeilenanker), unabhängig von Boxen
            var cv = null, rad = NaN, frei = NaN, voll = NaN, ausnahme = null;
            try { self.layout(idx); cv = self.renderPrintCanvas(idx); rad = self.druckRadiusMm(cv); frei = self.pruefRadiusMm(idx); voll = self.endRadiusMm(idx); breite['druck' + idx] = druckBreiteMm(cv); } catch (ex) { ausnahme = ex; }
            if (ausnahme || !(rad > 0 && rad <= CHECK_R_MM) || !(frei > 0 && frei <= CHECK_R_MM) || !(voll > 0 && voll <= CHECK_R_MM)) {
              var ve = new Error(self.errVorbereitung()); ve.vorbereitung = true; ve.radius = rad; ve.frei = frei; ve.voll = voll;
              if (window.console) console.error('[rlg-perso] Endkontrolle Druck-PNG Seite ' + (idx + 1) + ': ' + (ausnahme ? 'Ausnahme ' + (ausnahme && ausnahme.name) : rad + ' mm, ohne Kreis ' + frei + ' mm, ganze Leinwand ' + voll + ' mm'));
              throw ve;
            }
            return canvasToBlob(cv, 'image/png');
          }).then(function (blob) {
            return self.sign('druck-' + (idx + 1), 'image/png', blob.size).then(function (res) {
              return self.put(res.signedUrl, blob, 'image/png', true).then(function () {
                result['druck' + idx] = res.path;
                return sha256Hex(blob).then(function (h) { sha['druck' + idx] = h; });
              });
            });
          });
        })(j);
      }
      // 3. Vorschau-PNG
      p = p.then(function () { return self.renderPreviewBlob(); }).then(function (blob) {
        return self.sign('vorschau', 'image/png', blob.size).then(function (res) {
          return self.put(res.signedUrl, blob, 'image/png', true).then(function () {
            result.vorschau = res.path;
            return sha256Hex(blob).then(function (h) { sha.vorschau = h; });
          });
        });
      });
      return p;
    }
    this.enqueue(function () {
      return runChain().catch(function (e) {
        // 409 CODE_ABGELAUFEN (Code älter als 24 h): Code verwerfen, Originale neu hochladen, einmal neu signieren
        if (e && e.grund === 'CODE_ABGELAUFEN') { self.resetCode(); return runChain(); }
        throw e;
      });
    }).then(function () {
      // Sperre lösen, bevor geprüft wird: Ab hier läuft alles synchron bis zum Absenden, die Häkchen zählen wieder (08.10.2026)
      self.setBusy(false);
      // alle Dateien müssen unter genau einem Motiv-Code liegen
      var paths = Object.keys(result).map(function (k) { return result[k]; });
      if (!self.code || paths.some(function (pth) { return String(pth).indexOf(self.code + '/') !== 0; })) throw new Error(t.upload_fehler);
      // Während der Vorbereitung geändert (Variante, Motiv, Häkchen, jede Motivänderung per rev – auch hin und zurück)? Dann nichts in den Warenkorb legen.
      var idNow = (self.form.querySelector('[name="id"]') || {}).value;
      if (self.ball !== snap.ball || self.sides !== snap.sides || idNow !== snap.variant || self.artOf(0) + ',' + self.artOf(1) !== snap.arts || self.rev !== snap.rev || !allChecked() || !self.variantConsistent()) {
        var ge = new Error(t.geaendert); ge.changed = true; throw ge;
      }
      // sichtbare Property-Namen je Sprache (DE: Motiv-Code/Seite n/Freigabe, EN: Design code/Side n/Approval), versteckte (_…) immer gleich
      var pnSeite = t.pname_seite || 'Seite';
      var props = {};
      props[t.pname_code || 'Motiv-Code'] = self.code;
      props[pnSeite + ' 1'] = self.sideSummary(0);
      if (self.sides === 2) props[pnSeite + ' 2'] = self.sideSummary(1);
      props[t.pname_freigabe || 'Freigabe'] = t.prop_freigabe;
      var low = self.lowResSides();
      // 11.10.2026 (kompakt): bestätigte dpi-Abweichung zusätzlich SICHTBAR (Vertragsinhalt, § 476); low ≠ leer heißt: dpi-Häkchen
      // war Pflicht und ist gesetzt (validate + allChecked oben). Ohne die Texte (altes Snippet) entfällt nur das sichtbare Property.
      if (low.length && t.prop_aufloesung_name && t.prop_aufloesung_wert) props[safeVisible(t.prop_aufloesung_name)] = safeVisible(t.prop_aufloesung_wert);
      // 11.10.2026 (kompakt): Rechte/Widerruf sind nur noch Hinweise ohne Kästchen; altes Snippet (mit Häkchen) behält die alten Werte
      var hinweis = t.prop_hinweis || 'Hinweis angezeigt';
      props['_Rechte'] = $(self.root, '[data-rp-check="rechte"]') ? 'zugesichert' : hinweis;
      props['_Widerruf'] = $(self.root, '[data-rp-check="widerruf"]') ? 'Ausschluss zur Kenntnis genommen' : hinweis;
      props['_Ball'] = self.ball;
      if (low.length) {
        // Plan v2 Eintrag 63: gesondert bestätigte Abweichung (§ 476 Abs. 1 S. 2 BGB) – motive_holen.py warnt dazu
        // 09.10.2026: Format bleibt „Seite n W × H px …“ (W × H = Pixel ohne Rand), dazu gedruckte Breite und effektive dpi
        props['_Aufloesung'] = 'Unschärfe akzeptiert: ' + low.map(function (l) {
          return 'Seite ' + (l.idx + 1) + ' ' + l.w + ' × ' + l.h + ' px auf ' + round1(l.mm).replace('.', ',') + ' mm ≈ ' + l.dpi + ' dpi';
        }).join(', ') + ' (unter ' + REC_DPI + ' dpi)';
      }
      for (var i = 0; i < self.sides; i++) {
        var s = self.side[i], n = i + 1, L = self.layout(i), useImg = self.usesImage(i);
        var lines = self.textLines(i);
        props['_Druckdatei_' + n] = result['druck' + i];
        props['_SHA_Druck_' + n] = sha['druck' + i] || '';
        props['_Original_' + n] = useImg && s.origCode === self.code ? s.origPath : '';
        if (props['_Original_' + n]) props['_SHA_Original_' + n] = s.origSha || '';
        props['_Text_' + n] = lines.join(' / ');
        props['_Schrift_' + n] = lines.length ? self.fontById(s.font).name : '';
        props['_Farbe_' + n] = lines.length ? s.color : '';
        // Fix r3: gedruckte Tintenbreite = Alpha > 0 der hochgeladenen Druck-PNG (immer, auch im Rückfall); Lage/Drehung fest
        props['_Groesse_mm_' + n] = breite['druck' + i] > 0 ? round1(breite['druck' + i]) : (L ? round1((L.inkWmm != null ? L.inkWmm : L.W * L.k) * L.fit) : '');
        props['_Position_' + n] = '0.0,0.0';
        props['_Rotation_' + n] = '0';
        // Fix r4: Kern-Zuschnitt auf Wunsch (Punkte/Linien außen weggelassen) – nur dann; das Original ist unverändert hochgeladen
        if (useImg && s.kernAn && s.img === s.imgKern) {
          props['_Zuschnitt_' + n] = t.prop_zuschnitt || (self.cfg.lang === 'en' ? 'core (dots/lines around left out)' : 'Kern (Punkte/Linien außen weggelassen)');
        }
      }
      props['_Vorschau'] = result.vorschau;
      props['_SHA_Vorschau'] = sha.vorschau || '';
      self.setProps(props);
      self.setStatus('');
      self.allowSubmit = true;
      if (form.requestSubmit) {
        try { form.requestSubmit(submitter && submitter.form === form ? submitter : undefined); }
        catch (err) { form.requestSubmit(); }
      } else {
        var ev = new Event('submit', { bubbles: true, cancelable: true });
        if (form.dispatchEvent(ev)) form.submit();
      }
      // falls der Browser das Absenden verweigert hat (z. B. Formularprüfung), Flag zurücksetzen
      setTimeout(function () { self.allowSubmit = false; }, 0);
    }).catch(function (err) {
      self.setStatus('');
      self.setBusy(false);
      $(self.root, '[data-rp-props]').textContent = '';
      if (err && err.changed) {
        // 08.10.2026 (Review): Freigabe aufheben – der neue Stand muss geprüft und erneut bestätigt werden (Text t_geaendert)
        var fg = $(self.root, '[data-rp-check="freigabe"]');
        if (fg) fg.checked = false;
        self.showError(t.geaendert); return;
      }
      // 11.10.2026 (kompakt): Endkontrolle der Druck-PNG gescheitert → eigene Meldung, nichts in den Warenkorb
      if (err && err.vorbereitung) { self.showError(err.message); return; }
      self.showError(fill(t.err_senden, { fehler: (err && err.message) || t.err_netz }));
    });
  };

  // ------------------------------------------------------------------ 3D-Vorschau (08.10.2026): Andockstelle, ES5
  // cfg.d3 aus dem Snippet: { modus: 'an' | 'test', js, mv, mvSri, glb }. Fehlt d3 (alte Seite) oder das Markup (alte Seite mit neuem JS),
  // bleibt alles wie bisher. Merkmale ohne WebGL-Kontext: WebGL2 (three r183 kann kein WebGL 1), Module, customElements, SHA-256.
  function d3Merkmale() {
    try {
      return !!(window.WebGL2RenderingContext && window.customElements && window.Promise && window.fetch && window.URL && URL.createObjectURL &&
        window.crypto && window.crypto.subtle && window.HTMLScriptElement && ('noModule' in HTMLScriptElement.prototype));
    } catch (e) { return false; }
  }
  // Testmodus: nur mit ?rlg3d=1 (für den Tab gemerkt), ?rlg3d=0 vergisst es
  function d3Test() {
    var q = location.search || '', an = /[?&]rlg3d=1(&|$)/.test(q);
    try {
      if (an) sessionStorage.setItem('rlg3d', '1');
      else if (/[?&]rlg3d=0(&|$)/.test(q)) sessionStorage.removeItem('rlg3d');
      else an = sessionStorage.getItem('rlg3d') === '1';
    } catch (e) {}
    return an;
  }
  Perso.prototype.d3Init = function () {
    var self = this, r = this.root, d3 = this.cfg.d3, sw = $(r, '[data-rp-3d-schalter]');
    if (!d3 || !sw || !$(r, '[data-rp-3d]') || this.cfg.paused || !(d3.modus === 'an' || (d3.modus === 'test' && d3Test())) || !d3Merkmale()) return;
    this.d3 = { zustand: 'aus', ctl: null, laden: null, gen: 0, klick: 0, kreis: true, gesperrt: false };
    $$(sw, '[data-rp-ansicht]').forEach(function (b) {
      b.addEventListener('click', function () { self.d3Ansicht(b.getAttribute('data-rp-ansicht')); });
    });
    var k = $(r, '[data-rp-3d-kreis]');
    if (k) k.addEventListener('click', function () {
      self.d3.kreis = !self.d3.kreis;
      k.setAttribute('aria-pressed', self.d3.kreis ? 'true' : 'false');
      self.d3Ruf('kreis', self.d3.kreis);
    });
    window.addEventListener('pagehide', function () { self.d3Freigeben(); });
    sw.hidden = false;
  };
  Perso.prototype.d3Ruf = function (name, arg) {
    var d = this.d3;
    if (!d || !d.ctl) return;
    try { d.ctl[name](arg); } catch (e) { this.d3Fehler(e); }
  };
  Perso.prototype.d3Knoepfe = function (art) {
    $$(this.root, '[data-rp-ansicht]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-rp-ansicht') === art ? 'true' : 'false'); });
  };
  Perso.prototype.d3Status = function (txt, art) {
    var s = $(this.root, '[data-rp-3d-status]');
    if (!s) return;
    clearTimeout(this.d3Uhr);
    s.textContent = txt || '';
    s.className = 'rlg-perso__3d-status' + (art === 'sr' ? ' is-sr' : '');
    if (txt && art !== 'laedt') this.d3Uhr = setTimeout(function () { s.textContent = ''; }, art === 'sr' ? 3000 : 8000);
  };
  // 3D am Platz der 2D-Vorschau: 2D-Canvas unsichtbar und aus der Tab-Folge, Bedienhinweis/Legende und Knopf „Druckkreis“ für 3D
  Perso.prototype.d3Zeigen = function (an) {
    var r = this.root, h = $(r, '[data-rp-3d]'), cv = this.canvas;
    $(r, '.rlg-perso__stage').classList.toggle('is-3d', an);
    h.hidden = !an;
    h.classList.remove('is-laedt');
    // 11.10.2026 (kompakt): Canvas ist nicht mehr bedienbar → kein tabindex (auch nicht beim Zurück auf 2D)
    cv.removeAttribute('tabindex');
    if (an) cv.setAttribute('aria-hidden', 'true'); else cv.removeAttribute('aria-hidden');
    // 11.10.2026 (kompakt): 2D-Bedienhinweis [data-rp-bedienung] nie wieder einblenden; 3D-Hinweis und Legenden je für sich schalten
    var b3 = $(r, '[data-rp-3d-bedienung]'), l2 = $(r, '[data-rp-legende]'), l3 = $(r, '[data-rp-3d-legende]');
    if (b3) b3.hidden = !an;
    if (l2) l2.hidden = an;
    if (l3) l3.hidden = !an;
    var k = $(r, '[data-rp-3d-kreis]');
    if (k) k.hidden = !an;
  };
  Perso.prototype.d3Ansicht = function (art) {
    var self = this, d = this.d3;
    if (!d) return;
    if (art !== '3d') {
      if (d.zustand === 'aus') return;
      d.zustand = 'aus';
      this.d3Knoepfe('2d'); this.d3Zeigen(false); this.d3Status('');
      this.d3Ruf('verbergen');
      return;
    }
    if (d.gesperrt) { this.d3Status(this.t.d3_fehler, 'fehler'); return; }
    if (d.zustand !== 'aus') return;
    this.d3Knoepfe('3d');
    if (d.ctl) {
      d.zustand = 'an'; this.d3Zeigen(true);
      this.d3Ruf('seite', this.active); this.d3Ruf('nah', this.view === 'nah'); this.d3Ruf('zeigen');
      return;
    }
    d.zustand = 'laedt';
    var h = $(this.root, '[data-rp-3d]'), gen = d.gen, klick = ++d.klick;
    h.hidden = false; h.classList.add('is-laedt');   // 2D bleibt sichtbar, bis 3D steht
    this.d3Status(this.t.d3_laedt, 'laedt');
    this.d3Laden().then(function (ctl) {
      if (gen !== d.gen || d.gesperrt) { try { ctl.schliesse(); } catch (e) {} return; }
      d.ctl = ctl;
      // 09.10.2026: 3D → 2D → 3D während des Ladens hängt mehrere Zweige an dasselbe d.laden – nur der jüngste Klick wertet aus
      if (klick !== d.klick) return;
      if (!d.kreis) self.d3Ruf('kreis', false);
      if (d.zustand === 'laedt') {
        d.zustand = 'an'; self.d3Zeigen(true);
        self.d3Ruf('seite', self.active); self.d3Ruf('nah', self.view === 'nah'); self.d3Ruf('zeigen');
        self.d3Status(self.t.d3_bereit, 'sr');
      } else if (d.zustand === 'aus') self.d3Ruf('verbergen');
    }, function (e) { if (gen === d.gen) self.d3Fehler(e); });
  };
  // Modul einmal laden (Zeitlimit 20 s), dann RlgPerso3D.oeffne – Netz nur GET an die URLs aus cfg.d3 (Prüfung im Modul)
  Perso.prototype.d3Laden = function () {
    var self = this, d = this.d3;
    if (d.laden) return d.laden;
    d.laden = new Promise(function (ok, nein) {
      if (window.RlgPerso3D) { ok(window.RlgPerso3D); return; }
      var s = document.createElement('script'), uhr = setTimeout(function () { nein(new Error('Zeitlimit 3D-Modul')); }, 20000);
      s.onload = function () { clearTimeout(uhr); if (window.RlgPerso3D) ok(window.RlgPerso3D); else nein(new Error('3D-Modul leer')); };
      s.onerror = function () { clearTimeout(uhr); nein(new Error('3D-Modul nicht geladen')); };
      s.src = self.cfg.d3.js;
      document.head.appendChild(s);
    }).then(function (M) {
      return M.oeffne(self, $(self.root, '[data-rp-3d]'), {
        fehler: function (e) { self.d3Fehler(e); },
        status: function (txt) { if (d.zustand === 'an') self.d3Status(txt, txt ? 'laedt' : ''); }
      });
    });
    return d.laden;
  };
  // Fehler (kein WebGL, Ladefehler, Zeitlimit, Prüfsumme, Kontextverlust): Meldung, zurück auf 2D, „3D“ für diesen Seitenaufruf aus
  Perso.prototype.d3Fehler = function (e) {
    var d = this.d3;
    if (!d || d.gesperrt) return;
    d.gesperrt = true; d.zustand = 'aus';
    if (window.console) console.warn('[rlg-perso] 3D aus:', e && e.message ? e.message : e);
    try { if (d.ctl) d.ctl.schliesse(); } catch (x) {}
    d.ctl = null;
    this.d3Zeigen(false); this.d3Knoepfe('2d');
    var b = $(this.root, '[data-rp-ansicht="3d"]');
    if (b) b.setAttribute('aria-disabled', 'true');
    this.d3Status(this.t.d3_fehler, 'fehler');
  };
  // pagehide: Speicher freigeben (Canvas 1 × 1, Element entfernt); danach steht 2D, ein neuer Klick lädt neu
  Perso.prototype.d3Freigeben = function () {
    var d = this.d3;
    if (!d) return;
    d.gen++;
    try { if (d.ctl) d.ctl.schliesse(); } catch (e) {}
    d.ctl = null; d.laden = null; d.zustand = 'aus';
    try { this.d3Zeigen(false); this.d3Knoepfe('2d'); this.d3Status(''); } catch (e) {}
  };

  // ------------------------------------------------------------------ Start
  function boot() {
    $$(document, '[data-rlg-perso]').forEach(function (root) {
      if (root._rlgPerso) return;
      try { root._rlgPerso = new Perso(root); }
      catch (e) { if (window.console) console.error('[rlg-perso]', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.RlgPerso = { boot: boot, _sniffType: sniffType, _fontCovers: fontCovers, _knockOutWhite: knockOutWhite };
})();
